import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  Spinner,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import DatePicker from "react-datepicker";
import { ConfirmationModal } from "../../../Common/Components/ConfirmationModal";
import { SingleDropdownListWithoutSearch } from "../../../Common/Components/SingleDropdownListWithoutSearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperclip,
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import Dropzone from "react-dropzone";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { FiChevronDown } from "react-icons/fi";
import $, { event } from "jquery";
import "../../Register/slideout.scss";
import "./slideout.scss";
import { resolve, reject } from "q";
import { Register as registersevice } from "../../../Common/Services/Register";
import { ToastContainer, toast } from "react-toastify";
// import { VendorSearch } from "../../../Common/Components/VendorSearch";   /* Added/Commented to improve speed of Journal Slideout */
import { VendorSearchTypeahead as VendorSearch } from "../../../Common/Components/VendorSearchTypeahead"; /* Added/Commented to improve speed of Journal Slideout */
import { Journal as Journalsevice } from "../../../Common/Services/Journal";
import { confirmAlert } from "react-confirm-alert";
import {
  RoleSubPermissionSetting,
  IPageSubPermissionRole,
} from "../../../Common/Services/RoleSubPermissionSetting";
import chevronRight from "../../../Common/Assets/Images/icons/bx-chevron-right.svg";
import { CommentBox } from "../../../Common/Components/CommentBox";
import { JournalLogHistory } from "./JournalLogHistory";
import { Utils } from "../../../Common/Utilis";
import ScrollContainer from "react-indiana-drag-scroll";
import PDFViewerNonInvoice from "../../Register/pdfviewerNonInvoice";
import _ from "lodash";

let docViewerFiles: any = [];

export class TransactionSlideout extends React.Component<any, any> {
  private trdate: any;
  private trdate1: any;
  private trenddate: any;
  private vendorSearch: any;
  private pageName = "TransactionPage";
  private ChildComment: any;
  private parentScroll: any;

  private footerchk: any;
  private scrollheight: any;

  constructor(props: any) {
    super(props);
    this.vendorSearch = React.createRef();
    this.trdate = React.createRef();
    this.trdate1 = React.createRef();
    this.trenddate = React.createRef();
    this.ChildComment = React.createRef();
    this.parentScroll = React.createRef();

    this.footerchk = React.createRef();
    this.scrollheight = React.createRef();

    this.state = {
      isError: "",
      htmlcomment: [],
      isComment: false,
      hidValue: props.hidValue,
      hotelName: props.hotelName,
      isToggleRepeat: false,
      isToggleReversal: false,
      createOther: false,
      alertModalshow: false,
      isSpinner: false,
      isPermission: "Yes",
      savedfiles: [],
      totalCount: 0,
      files: [],
      newSelectedfiles: [],
      vendorList: [],
      accPeriodList: [],
      revAccPeriodList: [],
      coaList: [],
      totalCreditAmount: 0.0,
      totalDebitAmount: 0.0,
      transTotalAmount: 0.0,
      tabEnable: 0,
      tabDisable: -1,
      isPreviousTransactions: false,
      showChangeLogModal: false,
      moreAction: [
        { name: "Reverse", eventKey: "reverse" },
        { name: "Copy", eventKey: "copy" },
        { name: "Delete", eventKey: "deleteJEntry" },
        { name: "Change Log", eventKey: "changeLog" },
      ],
      hasDeleteAccess: false,
      hasDeletePermission: false,
      hasEditPermission: false,

      defaultaccountingPeriod: "Accounting Period",
      defaultReversalAcPeriod1: "Accounting Period",
      defaultReversalAcPeriod: "Accounting Period",
      defaultReversalDate: "",
      moreActionFileUpload: [{ name: "Delete", eventKey: "delete" }],
      moreActionFileUpload1: [
        { name: "Delete", eventKey: "deleteFile" },
        { name: "Download", eventKey: "download" },
      ],
      requestlist: { hotelID: 0, tenantID: 0, Vid: 0, recordCount: 5 },
      isChangeJE: false,
      isUpdateRecord: false,
      previousTransactionsData: [],
      isDisabled: false,
      splitData: [
        {
          rno: 1,
          coa: "",
          coaName: "",
          coaError: "",
          defaultCoa: [],
          description: "",
          debit: "",
          credit: "",
        },
        {
          rno: 2,
          coa: "",
          coaName: "",
          coaError: "",
          defaultCoa: [],
          description: "",
          debit: "",
          credit: "",
        },
      ],
      newRow: {
        rno: 1,
        coa: "",
        coaName: "",
        coaError: "",
        defaultCoa: [],
        description: "",
        debit: "",
        credit: "",
      },
      formData: {
        tenantID: 0,
        UniqueNo: 0,
        BackHid: 0,
        LoginUser: "",
        Vid: 0,
        contract: "",
        vendorName: "",
        accPeriodstatus: "",
        concilestatus: "",
        Date: "",
        AcPeriod: "",
        TransTotal: 0,
        Internalnotes: "",
        IsReversal: 0,
        ReversalDate: "",
        ReversalAcPeriod: "",
        IsRepete: 0,
        RepeatDate: "No End Date",
        saletax: "",
        vendorContract: "",
        aid: 0,
        actionType: "",
        adj: "N",
        oldentryType: "",
        oldpageType: "",
        vendorDays: "0",
        vendorStatus: "Active",
        contractStatus: "InActive",
        copyFromentryType: "",
        iscopyAttachment: "",
      },
      JERequests: {
        UniqueNo: 0,
        Vid: 0,
        vendorName: "",
        BackHid: 0,
        Date: "",
        AcPeriod: "",
        TransTotal: 0,
        Internalnotes: "",
        IsReversal: 0,
        LoginUser: "",
        IsRepete: 0,
        oldUniqueNo: 0,
      },
      newRequest: props.newRequest,
      isSplitUpdated: "No",
      oldAcPer: "",
      oldTranDate: "",
      isNeedToChange: true,
      splitActualList: [],
      isCopyEntry: false,

      isOpenViewer: false,
      defaultView: "doc-view",
      isMapped: "No",
      isMappedShow: false,
      chkIds: [],
      currentZoom: 1.0,
      selectedChk: [],
      isAttachmentLoading: false,

      tempUniqueNo: "",
      slideEntryType: "oldEntry",
      isCopyHasAttachment: false,
      currentScreenTop: 0,
      repeatList: [{id: 1, name: 'Monthly', displayName: "Monthly",}, {id: 2, name: 'Every 2 Weeks', displayName: "Every 2 Weeks"}, {id: 3, name: 'Weekly', displayName: "Weekly"}],
      selectedRepeatType: "Monthly",
    };
    this.handleVendorChange = this.handleVendorChange.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }

  componentDidMount() {
    console.warn = () => {};
    this.reCallApis();
  }
  reCallApis = () => {
    let requestlist = { ...this.state.requestlist };
    let formData = { ...this.state.formData };
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let JERequests = { ...this.props.JERequest };
    requestlist.hotelID = this.props.hidValue;
    requestlist.tenantID = tenantID;
    this.setState({ requestlist }, () => {
      if (JERequests.UniqueNo === 0) {
        formData.tenantID = tenantID;
        formData.LoginUser = storage.userName;
        formData.BackHid = this.props.hidValue;
        formData.accPeriodstatus = "Active";
        formData.concilestatus = "No";

        let accRequest: any = {};
        accRequest.hotelID = this.props.hidValue;
        accRequest.etype = "Journal";

        let vendorReg: any = {};
        vendorReg.hotelID = this.props.hidValue;
        // this.vendorSearch?.current.GetVendorTranlist(vendorReg);   /* Added/Commented to improve speed of Journal Slideout */
        this.GetAccountingPeriod(accRequest);

        this.setState({ formData, requestlist, hasEditPermission: true });
      }
    });

    if (JERequests.UniqueNo > 0 && this.props.isFromRepeating) {
      this.setState({ isSpinner: true, isToggleRepeat: true }, () => {
        this.getJERepeatingEntryData();
      });
    } else if (JERequests.UniqueNo > 0) {
      this.setState({ isSpinner: true }, () => {
        this.getJEEntryData();
      });
    } else if (JERequests.UniqueNo === 0) {
      this.GetTempUploadTransNo();
    }
  };

  GetTempUploadTransNo = () => {
    let request: any = {};
    request.EType = "Journal";
    registersevice
      .GetTempUploadTransNo(request)
      .then(async (result: any) => {
        if (result !== null) {
          this.setState(
            {
              tempUniqueNo: result.result,
              slideEntryType: "newEntry",
              currentScreenTop: 0,
            },
            () => {
              if (this.state.isCopyHasAttachment) {
                this.SaveCopyTempWithFile([]);
              }
            }
          );
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        setTimeout(() => {
          this.closeSlideOut();
        }, 1500);
        reject();
      });
  };

  closeSlideOut = () => {
    if (!this.state.isUpdateRecord && !this.state.newRequest) {
      this.isValidateModelPoupTab();
    } else {
      this.setState({
        JERequests: {
          UniqueNo: 0,
          Vid: 0,
          vendorName: "",
          BackHid: 0,
          Date: "",
          AcPeriod: "",
          TransTotal: 0,
          Internalnotes: "",
          IsReversal: 0,
          LoginUser: "",
          IsRepete: 0,
        },
      });
      this.props.hideSlideOut(this.state.isChangeJE);
    }
  };
  scrollToBottom = () => {
    this.parentScroll.current.scrollTo({
      //top: this.parentScroll.current.clientHeight,
      top: this.parentScroll.current.scrollHeight,
      behavior: "smooth",
    });
  };

  updatedCommentItem = () => {
    let updatedItem: any = {};
    this.setState({ isChangeJE: true });
    updatedItem.transcationDate = this.state.formData.Date;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = "0.00";
    return updatedItem;
  };

  getJEEntryData = () => {
    let request: any = {};
    request.UniqueNo = this.props.JERequest.UniqueNo;
    request.hotelId = this.props.hidValue;
    request.etype = "Journal";
    let JERequests = { ...this.state.JERequests };
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let regex = /[,\s]/g;
    Journalsevice.GetJournalByUniQueNo(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let splitData = result.journalList.filter(
            (item) => item.viewType === 2
          );
          let uploadFiles = result.uploadFileList;
          let isError = splitData[0].isError;
          if (isError === "Yes") {
            window.location.href = "/unauthorize-access?Error=NotFound";
          } else {
            for (let i = 0; i < uploadFiles.length; i++) {
              this["myRef" + i] = React.createRef();
            }
            JERequests.UniqueNo = splitData[0].uniqueno;
            JERequests.Vid = splitData[0].vid;
            JERequests.vendorName = splitData[0].vendor;
            JERequests.aid = 0; //splitData[0].aid;
            JERequests.saleTax = "Yes"; //splitData[0].saleTax;
            JERequests.vendorStatus = splitData[0].vendorStatus;
            JERequests.vendorDays = 0;
            JERequests.accPeriodstatus = splitData[0].accPerStatus;
            JERequests.contractStatus = splitData[0].contractStatus;
            JERequests.BackHid = splitData[0].backHID;
            JERequests.Date = splitData[0].date;
            JERequests.LoginUser = storage.userName;
            JERequests.AcPeriod = splitData[0].accper;
            JERequests.TransTotal = Number(
              splitData[0].transTotal.replace(/,/g, "")
            ).toFixed(2); ///parseFloat((splitData[0].transTotal).replace(regex, ""));
            JERequests.Internalnotes = splitData[0].internalnotes;
            JERequests.contract = splitData[0].contract;
            JERequests.IsReversal = 0;
            JERequests.IsRepete = 0;
            JERequests.JournalSplits = [];

            let hotelName = splitData[0].lettercode;
            for (let i = 0; i < splitData.length; i++) {
              if (Number(splitData[i].dr) !== 0) {
                let drRow: any = {};
                drRow.rno = i;
                drRow.coa = splitData[i].coa.toString();
                drRow.coaName = `${splitData[i].coa} ${splitData[i].coaName}`;
                drRow.description = splitData[i].description;
                drRow.defaultCoa = [];
                drRow.debit = splitData[i].dr; //Number(splitData[i].dr.replace(/,/g, "")).toFixed(2);
                drRow.credit = "0.00";
                drRow.IsCOAPer = splitData[i]?.isCOAPer;
                JERequests.JournalSplits.push(drRow);
              } else {
                let crRow: any = {};
                crRow.rno = i;
                crRow.coa = splitData[i].coa.toString();
                crRow.coaName = `${splitData[i].coa} ${splitData[i].coaName}`;
                crRow.description = splitData[i].description;
                crRow.defaultCoa = [];
                crRow.debit = "0.00";
                crRow.credit = splitData[i].cr; //Number(splitData[i].cr.replace(/,/g, "")).toFixed(2);
                crRow.IsCOAPer = splitData[i]?.isCOAPer;
                JERequests.JournalSplits.push(crRow);
              }
            }
            let requestlist = { ...this.state.requestlist };
            let tenantID = storage === null ? 0 : (storage.tenantID as any);
            requestlist.hotelID = splitData[0].backHID;
            requestlist.tenantID = tenantID;
            let fileList: any = [];
            uploadFiles.forEach((item) => {
              item.newname = item.name.toString().toLowerCase();
              fileList.push(item);
            });
            fileList = _.sortBy(fileList, "newname");
            this.setState(
              (prevState) => ({
                hidValue: splitData[0].backHID,
                hotelName: hotelName,
                JERequests,
                isError: isError,
                requestlist,
                isComment: true,
                oldAcPer:
                  splitData[0]
                    .accper /*isToggleReversal: splitData[0].isReversal,*/,
                splitActualList: splitData,
                savedfiles: fileList,
                isOpenViewer: fileList.length > 0,
              }),
              () => {
                this.getJournalEntry();
                this.getUploadedFileList();
                this.GetTransactionComment();
                this.getWebTimeClockManagerPermission();
                let accRequest: any = {};
                accRequest.hotelID = splitData[0].backHID;
                accRequest.etype = "Journal";
                this.GetAccountingPeriod(accRequest);
                let vendorReg: any = {};
                vendorReg.hotelID = splitData[0].backHID;
                // this.vendorSearch?.current.GetVendorTranlist(vendorReg);   /* Added/Commented to improve speed of Journal Slideout */
              }
            );
            resolve();
          }
        } else {
          window.location.href = "/unauthorize-access?Error=NotFound";
          // Utils.toastError("Something went wrong.", {
          //     position: toast.POSITION.BOTTOM_RIGHT,
          //     containerId: "JESave",
          // });
        }
      })
      .catch((error) => {
        reject();
      });
  };

  getJERepeatingEntryData = () => {
    let request: any = {};
    request.UniqueNo = this.props.JERequest.UniqueNo;
    let JERequests = { ...this.state.JERequests };
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let regex = /[,\s]/g;
    Journalsevice.JournalRepeatlistByUniQueNo(request)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          let splitData = result.filter((item) => item.viewType === 2);
          let JournalDF: any = [];
          let JournalDT: any = [];

          let isError = splitData[0].isError;
          if (isError === "Yes") {
            window.location.href = "/unauthorize-access?Error=NotFound";
          } else {
            JERequests.UniqueNo = splitData[0].uniqueno;
            JERequests.Vid = splitData[0].vid;
            JERequests.contract = splitData[0].contract;
            JERequests.vendorName = splitData[0].vendor;
            JERequests.BackHid = splitData[0].backHID;
            JERequests.Date = splitData[0].date;
            JERequests.LoginUser = storage.userName;
            JERequests.AcPeriod = splitData[0].accper;
            // JERequests.TransTotal = Number(splitData[0].transTotal.replace(/,/g, "")).toFixed(2);//parseFloat((splitData[0].transTotal).replace(regex, ""));
            JERequests.TransTotal = splitData[0].transTotal; //Utils.currencyFormat(splitData[0].transTotal);
            JERequests.Internalnotes = splitData[0].internalnotes;
            JERequests.contract = splitData[0].contract;
            JERequests.IsReversal = 0;
            JERequests.IsRepete = 1;
            JERequests.RepeatDate = splitData[0].endDate;
            JERequests.JournalSplits = [];

            let hotelName = splitData[0].lettercode;
            for (let i = 0; i < splitData.length; i++) {
              if (Number(splitData[i].dr) !== 0) {
                let drRow: any = {};
                drRow.rno = i;
                drRow.coa = splitData[i].coa.toString();
                drRow.coaName = `${splitData[i].coa} ${splitData[i].coaName}`;
                drRow.description = splitData[i].description;
                drRow.defaultCoa = [];
                drRow.debit = splitData[i].dr; //Utils.currencyFormatWithOutdoller(splitData[i].dr);
                drRow.credit = "0.00";
                drRow.IsCOAPer = splitData[i]?.isCOAPer;
                JERequests.JournalSplits.push(drRow);
              } else {
                let crRow: any = {};
                crRow.rno = i;
                crRow.coa = splitData[i].coa.toString();
                crRow.coaName = `${splitData[i].coa} ${splitData[i].coaName}`;
                crRow.description = splitData[i].description;
                crRow.defaultCoa = [];
                crRow.debit = "0.00";
                crRow.IsCOAPer = splitData[i]?.isCOAPer;
                crRow.credit = splitData[i].cr; //Utils.currencyFormatWithOutdoller(splitData[i].cr);
                JERequests.JournalSplits.push(crRow);
              }
            }

            let requestlist = { ...this.state.requestlist };
            let tenantID = storage === null ? 0 : (storage.tenantID as any);

            requestlist.hotelID = splitData[0].backHID;
            requestlist.tenantID = tenantID;

            this.setState(
              {
                selectedRepeatType: splitData[0].repeatType,
                hidValue: splitData[0].backHID,
                hotelName: hotelName,
                JERequests,
                isError: isError,
                requestlist,
                isComment: true,
                oldTranDate: splitData[0].date,
                splitActualList: splitData,
              },
              () => {
                this.getJournalEntry();
                //this.getUploadedFileList();
                this.GetTransactionComment();
                this.getWebTimeClockManagerPermission();
                let accRequest: any = {};
                accRequest.hotelID = splitData[0].backHID;
                accRequest.etype = "Journal";
                this.GetAccountingPeriod(accRequest);
                let vendorReg: any = {};
                vendorReg.hotelID = splitData[0].backHID;
                // this.vendorSearch?.current.GetVendorTranlist(vendorReg);   /* Added/Commented to improve speed of Journal Slideout */
              }
            );
            resolve();
          }
        } else {
          window.location.href = "/unauthorize-access?Error=NotFound";
        }
      })
      .catch((error) => {
        reject();
      });
  };

  getJournalEntry() {
    let { JERequests } = this.state;
    let requestlist = { ...this.state.requestlist };
    let formData = { ...this.state.formData };
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let splitData: any = [];
    let TotalDebitAmount: any = [];
    let TotalCreditAmount: any = [];
    let vendorSelected: any = [];
    let vendorItem: any = {};
    requestlist.Vid = JERequests.Vid;
    vendorItem.id = JERequests.Vid;
    vendorItem.vendorName = JERequests.vendorName;
    vendorItem.accountNo = JERequests.contract;
    vendorItem.aid = JERequests.aid;
    vendorItem.saleTax = JERequests.saleTax;
    vendorItem.vendorStatus = JERequests.vendorStatus;
    vendorItem.vendorDays = JERequests.vendorStatus;
    vendorItem.contractStatus = JERequests.contractStatus;
    vendorSelected.push(vendorItem);
    formData.tenantID = tenantID;
    formData.UniqueNo = JERequests.UniqueNo;
    formData.BackHid = this.state.requestlist.hotelID;
    formData.LoginUser = storage.userName;
    formData.Vid = JERequests.Vid;
    formData.vendorName = JERequests.vendorName;
    formData.Date = JERequests.Date;
    formData.AcPeriod = JERequests.AcPeriod;
    formData.TransTotal = JERequests.TransTotal;
    formData.Internalnotes = JERequests.Internalnotes;
    formData.IsReversal = JERequests.IsReversal;
    formData.RepeatDate = this.props.isFromRepeating
      ? JERequests.RepeatDate
      : "No End Date";
    formData.accPeriodstatus = JERequests.accPeriodstatus;
    formData.concilestatus = JERequests.concilestatus;
    formData.IsRepete = this.props.isFromRepeating ? JERequests.IsRepete : 0;
    formData.accPeriodstatus = "Active";
    formData.concilestatus = "No";
    formData.contract = JERequests.contract;
    // JERequests.contract = splitData[0].contract;

    JERequests.JournalSplits.forEach((element) => {
      if (Number(element.debit) !== 0) {
        let coaName = Array.from(new Set(element.coaName.split(" ")))
          .join(" ")
          .toString();
        let defaultCOA: any = [];
        let objCOA: any = {};
        objCOA.id = element.coa.toString();
        objCOA.label = coaName;
        defaultCOA.push(objCOA);
        element.defaultCoa = defaultCOA;
        element.coaName = coaName;
        splitData.push(element);
        TotalDebitAmount.push(element.debit);
      } else {
        let coaName = Array.from(new Set(element.coaName.split(" ")))
          .join(" ")
          .toString();
        let defaultCOA: any = [];
        let objCOA: any = {};
        objCOA.id = element.coa.toString();
        objCOA.label = coaName;
        defaultCOA.push(objCOA);
        element.defaultCoa = defaultCOA;
        element.coaName = coaName;
        splitData.push(element);
        TotalCreditAmount.push(element.credit);
      }
    });

    this.setState(
      {
        isUpdateRecord: true,
        newRequest: false,
        totalDebitAmount: TotalDebitAmount.reduce(
          (a, b) => Number(a) + Number(b),
          0
        ),
        totalCreditAmount: TotalCreditAmount.reduce(
          (a, b) => Number(a) + Number(b),
          0
        ),
        splitData,
        requestlist,
        formData,
      },
      () => {
        // this.vendorSearch.current.handleSelectFromParent(vendorSelected);   /* Added/Commented to improve speed of Journal Slideout */
        if (vendorSelected[0].vendorName.length > 0) {
          /* Added/Commented to improve speed of Journal Slideout */
          this.VendorSearchlistWithKey(
            vendorSelected[0].vendorName,
            this.state.requestlist.hotelID,
            vendorSelected
          );
        }
        this.addTotalAmount(this.state.splitData);
      }
    );
  }

  // getJournalEntryFiles = () => {
  //     let JERequests = { ...this.state.JERequests }
  //     let fileRequest: any = {};
  //     fileRequest.UniqueNo = this.props.JERequest.UniqueNo;
  //     Journalsevice.GetJournalEntryFiles(fileRequest)
  //         .then(async (result: any | null) => {
  //             if (result !== null) {
  //                 this.setState({ savedfiles: result })
  //             }
  //             resolve();
  //         })
  //         .catch((error) => {
  //             reject();
  //         });
  // }

  getUploadedFileList = () => {
    let requestlist: any = {};
    requestlist.uniqueNo =
      this.state.slideEntryType === "newEntry"
        ? this.state.tempUniqueNo
        : this.props.JERequest.UniqueNo;
    requestlist.checkNo = "";
    requestlist.series = "A";
    requestlist.etype =
      this.state.slideEntryType === "newEntry" ? "TempUploadFiles" : "Journal"; //this.props.pageType.toUpperCase();

    this.setState({ isAttachmentLoading: true });
    registersevice
      .GetUploadFileWithFileCode(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            element.fileCode =
              "data:application/pdf;base64," + element.fileCode;
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          filelist = _.sortBy(filelist, "newname");
          this.setState(
            (prevState) => ({
              savedfiles: filelist,
              isAttachmentLoading: false,
              isOpenViewer: prevState.isOpenViewer,
              newSelectedfiles: [],
              files: [],
            }),
            () => {
              setTimeout(() => {
                this.scrollheight.current?.getElement().scrollTo({
                  top: Number(this.state.currentScreenTop),
                  behavior: "smooth",
                });
              }, 500);
            }
          );
        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
            bulkSelect: false,
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({
          isOpenViewer: false,
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
          bulkSelect: false,
        });
      });
  };

  GetTransactionComment = () => {
    let commentRequest: any = {};
    commentRequest.uniqueNo = this.props.JERequest.UniqueNo;
    commentRequest.etype = this.props.isFromRepeating
      ? "Journalrepeat"
      : "Journal";
    registersevice
      .GetTransactionComment(commentRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ htmlcomment: [], isComment: false }, () => {
            this.setState({ htmlcomment: result, isComment: true });
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  getWebTimeClockManagerPermission = () => {
    let localStorageUser = JSON.parse(localStorage.getItem("storage")!);
    let requestObject = {} as IPageSubPermissionRole;
    requestObject.permissionID = 148;
    requestObject.Module = "Accounting";
    requestObject.Type = "page";
    requestObject.RoleID = localStorageUser.rolId;
    requestObject.TenantID = localStorageUser.tenantID;
    RoleSubPermissionSetting.GetPageSubPermissionWebClockDetails(requestObject)
      .then(async (result: any | null) => {
        let { hasDeletePermission, hasEditPermission } = this.state;
        if (result != null && result.length > 0) {
          for (let index = 0; index < result.length; index++) {
            if (
              result[index].displayName.toString().toLowerCase() ===
                "Delete".toLocaleLowerCase() &&
              result[index].moduleName === "Accounting"
            ) {
              hasDeletePermission = true;
            } else if (
              result[index].displayName.toString().toLowerCase() ===
                "Edit".toLocaleLowerCase() &&
              result[index].moduleName === "Accounting"
            ) {
              hasEditPermission = true;
            }
          }
          let checkDel: any = {};
          checkDel.UniqueNo = this.state.formData.UniqueNo;
          checkDel.HID = this.state.formData.BackHid;
          checkDel.Type = "Journal";
          this.setState({ hasDeletePermission, hasEditPermission }, () => {
            this.checkForDelete(checkDel);
          });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "JESave",
        });
        reject();
      });
  };

  hasDeletePermission(item: any, idx: any, type) {
    //debugger;
    let hasPermission = false;
    if (type === "nonRepeat") {
      hasPermission =
        this.state.hasDeleteAccess && this.state.hasDeletePermission;
    } else {
      hasPermission = this.state.hasDeletePermission;
    }

    let addPerm = this.props?.hasAddPermission;

    if (
      hasPermission &&
      item.name === "Delete" &&
      type === "nonRepeat" &&
      this.state.formData.actionType !== "copy"
    ) {
      return (
        <Dropdown.Item eventKey={this.state.moreAction[idx].eventKey} key={idx}>
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    } else if (
      addPerm &&
      item.name === "Copy" &&
      type === "nonRepeat" &&
      this.state.formData.actionType !== "copy"
    ) {
      return (
        <Dropdown.Item eventKey={this.state.moreAction[idx].eventKey} key={idx}>
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    } else if (
      this.state.hasEditPermission &&
      item.name === "Reverse" &&
      type === "nonRepeat" &&
      this.state.formData.actionType !== "copy"
    ) {
      return (
        <Dropdown.Item eventKey={this.state.moreAction[idx].eventKey} key={idx}>
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    } else if (
      item.name !== "Delete" &&
      item.name !== "Copy" &&
      item.name !== "Reverse" &&
      type === "nonRepeat" &&
      this.state.formData.actionType !== "copy"
    ) {
      return (
        <Dropdown.Item eventKey={this.state.moreAction[idx].eventKey} key={idx}>
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    }
    // else if (item.name !== "Delete" && item.name !== "Copy" && type === "nonRepeat" && this.state.formData.actionType !== "copy") {
    //     return (
    //         <Dropdown.Item
    //             eventKey={this.state.moreAction[idx].eventKey}
    //             key={idx}
    //         >
    //             <>{this.state.moreAction[idx].name}</>
    //         </Dropdown.Item>
    //     );
    // }
    else if (item.name === "Change Log" && type === "nonRepeat") {
      return (
        <Dropdown.Item eventKey={this.state.moreAction[idx].eventKey} key={idx}>
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    }

    if (hasPermission && item.name === "Delete" && type === "Repeating") {
      return (
        <Dropdown.Item eventKey={this.state.moreAction[idx].eventKey} key={idx}>
          <>{this.state.moreAction[idx].name}</>
        </Dropdown.Item>
      );
    }
  }

  checkForDelete = (request) => {
    Journalsevice.CheckForDelete(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let hasAccess = result[0].result;
          if (hasAccess === "Yes") {
            this.setState({ hasDeleteAccess: true });
          } else {
            this.setState({ hasDeleteAccess: false });
          }
        } else {
          this.setState({ hasDeleteAccess: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ hasDeleteAccess: false });
        reject();
      });
  };

  handleSelect = (eventKey: any) => {
    let { formData } = this.state;
    let deleteEntryReq: any = {};
    deleteEntryReq.UniqueNo = formData.UniqueNo;
    deleteEntryReq.HID = formData.BackHid;
    deleteEntryReq.isrepeat = this.props?.isFromRepeating ? 1 : 0;
    if (eventKey === "deleteJEntry") {
      this.deleteJournalEntry(deleteEntryReq);
    }
    if (eventKey === "changeLog") {
      this.showHideChangeLogModal();
    }
    if (eventKey === "copy") {
      if (this.state.savedfiles.length > 0) {
        confirmAlert({
          title: "Copy Transaction",
          message:
            "Do you want to copy over the attachments to the new transaction?",
          buttons: [
            {
              label: "Yes",
              onClick: () => this.CopyTransaction("Yes", "copy"),
            },
            {
              label: "No",
              onClick: () => this.CopyTransaction("No", "copy"),
            },
          ],
          overlayClassName: "copy-trancsation-alert",
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.CopyTransaction("No", "copy");
      }
    }
    if (eventKey === "reverse") {
      if (this.state.savedfiles.length > 0) {
        confirmAlert({
          title: "Reverse Transaction",
          message:
            "Do you want to reverse over the attachments to the new transaction?",
          buttons: [
            {
              label: "Yes",
              onClick: () => this.CopyTransaction("Yes", "reverse"),
            },
            {
              label: "No",
              onClick: () => this.CopyTransaction("No", "reverse"),
            },
          ],
          overlayClassName: "copy-trancsation-alert",
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      } else {
        this.CopyTransaction("No", "reverse");
      }
    }
  };

  CopyTransaction = (iscopyFile, actionType) => {
    this.copyVendor(iscopyFile);
    let accPeriodList: any = [];
    let splitData: any = [];
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (actionType === "reverse") {
      splitData = splitData.map((s) => {
        if (s.credit === "0.00" && s.debit !== "") {
          s.credit = s.debit;
          s.debit = "0.00";
          return s;
        }
        if (s.debit === "0.00" && s.credit !== "") {
          s.debit = s.credit;
          s.credit = "0.00";
          return s;
        }
        return s;
      });
    }
    splitData = splitData.map((s) => {
      if (s.IsCOAPer?.toLowerCase() === "no") {
        s.defaultCoa = [];
        s.coa = "";
        s.coaName = "";
      }
      return s;
    });

    splitData = splitData.map((s) => {
      if (s.IsCOAPer?.toLowerCase() === "no") {
        s.IsCOAPer = "Yes";
      }
      return s;
    });
    accPeriodList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accPeriodList))
    );
    if (iscopyFile === "Yes") {
      this.setState(
        {
          defaultaccountingPeriod: this.state.defaultaccountingPeriod,
          defaultPeriod: this.state.defaultaccountingPeriod,
          accPeriodList: [],
          splitData: [],
        },
        () => {
          this.setState(
            {
              accPeriodList: accPeriodList,
              defaultaccountingPeriod: this.state.defaultaccountingPeriod,
              isStateChanged: true,
              defaultPeriod: this.state.defaultaccountingPeriod,
              splitData,
              isUpdateRecord: false,
              isDisabled: false,
              isSpinner: false,
              isCopyEntry: true,
              isCopyHasAttachment: true,
            },
            () => {
              this.GetTempUploadTransNo();
              toast.success(
                "The transaction has been " +
                  actionType +
                  " and is ready to make changes.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
              //console.log(this.state.files)
            }
          );
        }
      );
    } else {
      this.setState(
        {
          defaultaccountingPeriod: this.state.defaultaccountingPeriod,
          defaultaccountingPeriod1: this.state.defaultaccountingPeriod,
          isStateChanged: true,
          accPeriodList: [],
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
          defaultPeriod: this.state.defaultaccountingPeriod,
          splitData: [],
        },
        () => {
          this.setState(
            {
              accPeriodList: accPeriodList,
              isUpdateRecord: false,
              splitData,
              isDisabled: false,
              isSpinner: false,
              isCopyEntry: true,
              isOpenViewer: false,
            },
            () => {
              this.GetTempUploadTransNo();
              toast.success(
                "The transaction has been copied and is ready to make changes.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
              //console.log(this.state.formData)
            }
          );
        }
      );
    }
    let accRequest: any = {};
    accRequest.hotelID = this.state.hidValue;
    accRequest.etype = "Journal";
    this.GetAccountingPeriod(accRequest);
  };

  SaveCopyTempWithFile(files: any) {
    this.setState({ currentScreenTop: 0 });
    let { JERequests, entryType, tempUniqueNo } = this.state;
    let request: any = {};
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let acctType = "Journal";

    request.TenantID = tenantID;
    request.actionType = "Copy";
    request.UniqueNo = JERequests.uniqueno;
    request.iscopyAttachment = "Yes";
    request.TempUniqueNo = tempUniqueNo;
    request.oldUniqueNo = JERequests.oldUniqueNo;
    request.TypeFrom = acctType;
    request.OldTypeFrom = acctType;

    registersevice
      .SaveTempWithFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            this.setState({ isCopyHasAttachment: false }, () => {
              this.getUploadedFileList();
            });
          } else {
            Utils.toastError("Failed to upload attachment.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.setState(
              { isDisabled: false, isCopyHasAttachment: false },
              () => {
                this.getUploadedFileList();
              }
            );
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  copyVendor(iscopyFile) {
    let formData = { ...this.state.formData };
    let { JERequests } = this.state;
    formData.accPeriod = this.state.defaultaccountingPeriod;
    formData.iscopyAttachment = iscopyFile === "Yes" ? "yes" : "no";
    formData.accPeriodstatus = "Active";
    formData.adj = "N";
    formData.actionType = "copy";
    formData.Date = "";
    JERequests.oldUniqueNo = formData.UniqueNo;

    //formData.UniqueNo = 0;

    if (Number(this.state.formData.Vid) > 0) {
      if (this.state.formData.vendorStatus.toLowerCase() === "inactive") {
        let vendorSelected: any = [];
        let vendorItem: any = {};
        vendorItem.id = 0;
        vendorItem.accountNo = "";
        vendorItem.aid = 0;
        vendorItem.salestax = "";
        vendorItem.vendorName = "";
        vendorSelected.push(vendorItem);
        this.vendorSearch?.current.handleSelectFromParent(vendorSelected);

        formData.Vid = 0;
        formData.vendorName = "";
        formData.vendorContract = "";
        formData.aid = 0;
        formData.Date = "";
        formData.dueDate = null;
        formData.gDate = null;
        this.setState({ formData });
      } else if (
        this.state.formData.vendorStatus.toLowerCase() === "active" &&
        this.state.formData.contractStatus.toLowerCase() === "inactive"
      ) {
        this.setState({ formData }, () => {
          this.handleMultiContract(this.state.formData.BackHid);
        });
      } else if (
        this.state.formData.vendorStatus.toLowerCase() === "active" &&
        this.state.formData.contractStatus.toLowerCase() === "active"
      ) {
        this.setState({ formData });
      }
      let registerRequest: any = {};
      registerRequest.hotelID = this.state.hidValue;
    }
    this.setState({ formData, htmlcomment: [], isComment: false }, () => {
      this.setState({ isComment: true });
    });
  }

  handleMultiContract = (movedhidValue: any) => {
    this.contractDetails(
      movedhidValue,
      this.state.formData.vendorName,
      this.state.formData.Vid,
      "Current",
      "App"
    );
  };

  contractDetails = (movedhidValue, vendorName, vid, vendorType, approval) => {
    let vendorContractRequest: any = {};
    vendorContractRequest.hotelID = movedhidValue;
    vendorContractRequest.vendorType = vendorType;
    vendorContractRequest.VendorId = vid;
    registersevice
      .GetVendorContract(vendorContractRequest)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          if (result.length === 1) {
            let formData = { ...this.state.formData };
            formData.vendorContract = result[0].accountNo;
            formData.aid = result[0].aid;
            this.setState({ formData: formData });
            let vendorSelected: any = [];
            let vendorItem: any = {};
            vendorItem.id = this.state.formData.vendorID;
            vendorItem.accountNo = result[0].accountNo;
            vendorItem.aid = result[0].aid;
            vendorItem.salestax = result[0].salestax;
            vendorItem.vendorName = this.state.formData.vendorName;
            vendorSelected.push(vendorItem);
            this.vendorSearch?.current.handleSelectFromParent(vendorSelected);
          } else {
            this.vendorSearch?.current.contractDetails(
              vendorName,
              vid,
              vendorType,
              approval
            );
          }
        } else {
          this.vendorSearch.current.addNewContract(
            vendorName,
            vid,
            vendorType,
            movedhidValue
          );
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  pageClose = () => {
    this.setState({
      JERequests: {
        UniqueNo: 0,
        Vid: 0,
        vendorName: "",
        BackHid: 0,
        Date: "",
        AcPeriod: "",
        TransTotal: 0,
        Internalnotes: "",
        IsReversal: 0,
        LoginUser: "",
        IsRepete: 0,
      },
    });
    this.props.hideSlideOut(this.state.isChangeJE);
  };
  isValidateModelPoupTab() {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.pageClose(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  deleteJournalEntry = (request) => {
    confirmAlert({
      title: "Delete entry",
      message: "Are you sure you want to delete this entry?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            Journalsevice.DeleteJournalEntry(request)
              .then(async (result: any | null) => {
                if (
                  result.result.toString().toLowerCase() ===
                  "Success".toLocaleLowerCase()
                ) {
                  toast.success("Entry deleted successfully.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "JESave",
                  });
                  this.setState({
                    isChangeJE: true,
                    newRequest: true,
                    isUpdateRecord: true,
                  });
                  setTimeout(() => {
                    this.closeSlideOut();
                  }, 1000);
                }
                resolve();
              })
              .catch((error) => {
                this.setState({ hasDeleteAccess: false });
                reject();
              });
          },
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
    });
  };

  renderThreeDot = () => {
    let hasPermission = this.state.hasDeletePermission;

    if (hasPermission) {
      return (
        <div className="action-group d-flex">
          <Dropdown
            className="more-action"
            alignRight
            onSelect={this.handleSelect}
          >
            <Dropdown.Toggle
              className="btn-outline-primary btn btn-primary more"
              id="dropdown-more"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {this.state.moreAction.map((item: any, idx: any) => (
                <>{this.hasDeletePermission(item, idx, "Repeating")}</>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    } else {
      return <></>;
    }
  };

  onDrop = (files: any) => {
    let size = 5242880; //5MB
    let newfiles: any = [];
    //newfiles = Object.assign([], JSON.parse(JSON.stringify(this.state.newSelectedfiles)));
    let isReturn = true;
    let filestext = "";
    let i = 0;
    files.forEach((element) => {
      if (element.size > size) {
        i = i + 1;
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });
    if (!isReturn) {
      let msg = "";
      if (i === 1) {
        msg = filestext.split(",")[0] + " is greater than 5 MB.";
      } else {
        msg = filestext + " are greater than 5 MB.";
      }
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
      return isReturn;
    }
    this.state.newSelectedfiles.forEach((element) => {
      newfiles.push(element);
    });
    let isInvalidFile = false;
    files.forEach((element) => {
      let subEl = element.name
        .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
        .toLowerCase();
      if (
        subEl === "pdf" ||
        subEl === "doc" ||
        subEl === "docx" ||
        subEl === "xls" ||
        subEl === "xlsx" ||
        subEl === "csv" ||
        subEl === "txt" ||
        subEl === "bmp" ||
        subEl === "tif" ||
        subEl === "ppt" ||
        subEl === "pptx" ||
        subEl === "rtf" ||
        subEl === "jpg" ||
        subEl === "png" ||
        subEl === "msg" ||
        subEl === "eml"
      ) {
        let item: any = {};
        // item.fileUniqueNo = 0;
        // item.name = element.name;
        // item.type = element.type;
        newfiles.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    this.state.files.forEach((element) => {
      let subEl = element.name
        .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
        .toLowerCase();
      if (
        subEl === "pdf" ||
        subEl === "doc" ||
        subEl === "docx" ||
        subEl === "xls" ||
        subEl === "xlsx" ||
        subEl === "csv" ||
        subEl === "txt" ||
        subEl === "bmp" ||
        subEl === "tif" ||
        subEl === "ppt" ||
        subEl === "pptx" ||
        subEl === "rtf" ||
        subEl === "jpg" ||
        subEl === "png" ||
        subEl === "msg" ||
        subEl === "eml"
      ) {
        files.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (files.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      Utils.toastError(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
    }
    // newfiles.forEach(element => {
    //     files.push(element)
    // });
    // savedfiles
    newfiles = _.sortBy(newfiles, "name");
    this.setState(
      {
        files: newfiles,
        newSelectedfiles: newfiles,
        /*isUpdateRecord: false,*/ newRequest: false,
      },
      () => {
        this.SaveTempWithFile(newfiles);
      }
    );
  };

  SaveTempWithFile(files: any) {
    this.setState({ currentScreenTop: 0 });
    let { JERequests, slideEntryType, tempUniqueNo } = this.state;
    let request: any = {};
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let acctType = "Journal";
    request.TenantID = tenantID;
    request.actionType = "";
    request.iscopyAttachment = "No";
    request.TempUniqueNo = this.state.isToggleRepeat
      ? tempUniqueNo
      : slideEntryType === "newEntry"
      ? tempUniqueNo
      : "";
    request.UniqueNo = slideEntryType === "newEntry" ? 0 : JERequests.UniqueNo;
    request.oldUniqueNo =
      slideEntryType === "newEntry" ? 0 : JERequests.UniqueNo;
    request.TypeFrom = "Journal";
    request.OldTypeFrom =
      slideEntryType === "newEntry" ? "TempUploadFiles" : acctType;

    registersevice
      .SaveTempWithFile(request, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === "Success") {
            // toast.success("Attachment uploaded successfully", { position: toast.POSITION.BOTTOM_RIGHT });
            this.getUploadedFileList();
          } else {
            Utils.toastError("Failed to upload attachment.", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
            this.getUploadedFileList();
            this.setState({ isDisabled: false });
          }
        }

        resolve();
      })
      .catch((error) => {
        reject();
      });
  }

  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      let newfiles: any = [];
      this.state.newSelectedfiles.forEach((element, idx) => {
        if (index !== idx) {
          newfiles.push(element);
        }
      });
      this.setState({ newSelectedfiles: newfiles, files: newfiles });
    } else if (eventKey === "download") {
      this.downloadTranactionFile(file);
    } else if (eventKey === "deleteFile") {
      let deleteFileReq: any = {};
      deleteFileReq.uniqueno =
        this.state.slideEntryType === "newEntry"
          ? 0
          : this.state.formData.UniqueNo;
      deleteFileReq.fileNo = file.fileUniqueno;
      deleteFileReq.allDelete = "";
      deleteFileReq.type =
        this.state.slideEntryType === "newEntry"
          ? "TempUploadFiles"
          : "Journal";
      let fileno = file.fileNo;
      confirmAlert({
        title: "Delete Attachment",
        message: "Are you sure you want to delete this Attachment?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              Journalsevice.DeleteUploadedFile(deleteFileReq)
                .then(async (result: any | null) => {
                  if (result !== null) {
                    // toast.success("Attachment deleted successfully.", {
                    //     position: toast.POSITION.BOTTOM_RIGHT,
                    //     containerId: "JESave",
                    // });
                    this.getUploadedFileList();
                    for (let i = 0; i < this.state.savedfiles.length; i++) {
                      this["myRef" + i].current?.hanndleDeleteFile(
                        Number(fileno)
                      );
                    }
                  }
                  resolve();
                })
                .catch((error) => {
                  reject();
                });
            },
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],
      });
    }
  };

  onFileChange = (event: any, mode) => {
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        let fileRow = event.target.files[i];
        newfiles.push(fileRow);
      }
      this.onDrop(newfiles);
      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  GetHotelCOAlist = (requestlist: any) => {
    let splitData: any = [];
    let newRow: any = {};
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));
    registersevice
      .GetHotelCOAlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ splitData: [], newRow: {} }, () => {
            this.setState(
              {
                splitData: splitData,
                newRow: newRow,
                coaList: result.transactionChartList,
              },
              () => {
                let formData = { ...this.state.formData };
                //this.GetTransactionEntryColoumn(formData);
              }
            );
          });
        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  };

  downloadTranactionFile = (file: any) => {
    file.uniqueNo =
      this.state.slideEntryType === "newEntry"
        ? this.state.tempUniqueNo
        : file.uniqueNo;
    file.etype = "Journal";
    registersevice
      .DownloadTranactionFile(file)
      .then(async (result: any | null) => {
        // let csvURL = window.URL.createObjectURL(result);
        // let tempLink = document.createElement("a");
        // tempLink.href = csvURL;
        // tempLink.setAttribute("download", file.name);
        // tempLink.click();
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "JESave",
        });
        reject();
      });
  };

  getReversalACPer = (accPer: any, defaultPeriod) => {
    let newArray: any = [];
    accPer.forEach((element: any, index: any) => {
      element.newid = index + 1;
      newArray.push(element);
    });
    let currentX = newArray.filter(
      (item: any) => item.accperiod === defaultPeriod
    );
    let cNo: any;
    let newX = Number(currentX[0].newid);
    if (newArray.length <= newX) {
      cNo = newX;
    } else {
      cNo = newX; //+ 1;
    }
    let currentNewAccPer = newArray.filter(
      (item: any) => Number(item.newid) === cNo
    );
    return currentNewAccPer[0].accperiod;
  };

  GetAccountingPeriod = (request: any) => {
    let JERequests = { ...this.state.JERequests };
    this.setState({ isSpinner: true });
    let accPeriod: any = [];
    accPeriod = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.accPeriodList))
    );
    registersevice
      .GetAccountingPeriod(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let isPermission;
          if (result.length > 0) {
            isPermission = "Yes";
            result.forEach((element) => {
              let item: any = {};
              item.id = element.accperiod;
              item.name = element.accperiod;
              item.defaultPeriod = element.defaultPeriod;
              accPeriod.push(item);
            });
            let hasEntryButNotAccPer = true;
            let hasEntryandAccPer = true;
            if (JERequests.UniqueNo > 0) {
              hasEntryButNotAccPer = accPeriod.some(
                (item) =>
                  item.name === JERequests.AcPeriod &&
                  item.defaultPeriod !== JERequests.AcPeriod
              );
              hasEntryandAccPer = accPeriod.some(
                (item) =>
                  item.name === JERequests.AcPeriod &&
                  item.defaultPeriod === JERequests.AcPeriod
              );
              if (hasEntryButNotAccPer) {
                this.setState({ accPeriodList: [] }, () => {
                  if (accPeriod.length > 0) {
                    let formData = { ...this.state.formData };
                    let defaultper = JERequests.AcPeriod;
                    formData.AcPeriod = defaultper;
                    this.setState({
                      isPermission,
                      revAccPeriodList: result,
                      defaultaccountingPeriod: defaultper,
                      formData,
                    });
                  }
                  this.setState(
                    { accPeriodList: accPeriod, isEditabble: true },
                    () => {
                      let coaRequest: any = {};
                      coaRequest.hotelID = this.state.requestlist.hotelID;
                      this.GetHotelCOAlist(coaRequest);
                    }
                  );
                });
              } else if (hasEntryandAccPer) {
                this.setState({ accPeriodList: [] }, () => {
                  if (accPeriod.length > 0) {
                    let formData = { ...this.state.formData };
                    let ReversalAcPeriod = this.getReversalACPer(
                      result,
                      result[0].defaultPeriod
                    );
                    let defaultper = result[0].defaultPeriod;
                    formData.AcPeriod = defaultper;
                    if (
                      this.state.formData.actionType === "Copy" ||
                      this.state.formData.actionType === "copy"
                    ) {
                      accPeriod = [];
                      result.forEach((element) => {
                        let item: any = {};
                        item.id = element.accperiod;
                        item.name = element.accperiod;
                        item.defaultPeriod = element.defaultPeriod;
                        accPeriod.push(item);
                      });
                    }
                    this.setState({
                      isPermission,
                      defaultReversalDate: ReversalAcPeriod,
                      revAccPeriodList: result,
                      defaultaccountingPeriod: defaultper,
                      defaultReversalAcPeriod1: ReversalAcPeriod,
                      formData,
                    });
                  }
                  this.setState(
                    { accPeriodList: accPeriod, isEditabble: true },
                    () => {
                      let coaRequest: any = {};
                      coaRequest.hotelID = this.state.requestlist.hotelID;
                      this.GetHotelCOAlist(coaRequest);
                    }
                  );
                });
              } else if (this.props.isFromRepeating) {
                isPermission = "Yes";
                this.setState({
                  isPermission,
                  isSpinner: false,
                  accPeriodList: accPeriod,
                });
                let coaRequest: any = {};
                coaRequest.hotelID = this.state.requestlist.hotelID;
                this.GetHotelCOAlist(coaRequest);
              } else {
                let formData = { ...this.state.formData };
                let newArray = [
                  {
                    id: JERequests.AcPeriod,
                    name: JERequests.AcPeriod,
                    defaultPeriod: JERequests.AcPeriod,
                  },
                ];
                let defaultper = JERequests.AcPeriod;
                formData.AcPeriod = defaultper;
                this.setState({
                  isPermission: "No",
                  accPeriodList: newArray,
                  defaultaccountingPeriod: defaultper,
                  isEditabble: false,
                  formData,
                  isSpinner: false,
                });
              }
            } else {
              this.setState({ accPeriodList: [] }, () => {
                if (accPeriod.length > 0) {
                  //&& this.state.JERequests.UniqueNo === 0
                  let formData = { ...this.state.formData };
                  let ReversalAcPeriod = this.getReversalACPer(
                    result,
                    result[0].defaultPeriod
                  );
                  let defaultper = result[0].defaultPeriod;
                  formData.AcPeriod = defaultper;

                  this.setState({
                    isPermission,
                    defaultReversalDate: ReversalAcPeriod,
                    revAccPeriodList: result,
                    defaultaccountingPeriod: defaultper,
                    defaultReversalAcPeriod1: ReversalAcPeriod,
                    formData,
                  });
                }
                this.setState(
                  {
                    accPeriodList: accPeriod,
                    isEditabble: true,
                    isSpinner: false,
                  },
                  () => {
                    let coaRequest: any = {};
                    coaRequest.hotelID = this.state.requestlist.hotelID;
                    this.GetHotelCOAlist(coaRequest);
                  }
                );
              });
            }
          } else {
            isPermission = "No";
            this.setState({ isPermission, isSpinner: false });
          }
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "JESave",
        });
        reject();
      });
  };

  handleToggleChange = (event: any, FieldType: string) => {
    let formData = { ...this.state.formData };
    this.setState({ formData });
    let { defaultReversalAcPeriod1, defaultReversalAcPeriod } = this.state;
    let isToggleRepeat = false;
    let isToggleReversal = false;
    let isChecked = event.target.checked;
    if (isChecked && FieldType === "reversal") {
      formData.ReversalAcPeriod = defaultReversalAcPeriod1;
      // formData.ReversalDate = defaultReversalAcPeriod1;
      defaultReversalAcPeriod = defaultReversalAcPeriod1;
      this.setState({ isOpenViewer: false });
    } else {
      formData.ReversalAcPeriod = "";
      formData.ReversalDate = "";
      defaultReversalAcPeriod = "";
    }
    if (!isChecked && FieldType === "repeat") {
      formData.RepeatDate = "No End Date";
    }
    if (FieldType === "repeat") {
      formData.ReversalAcPeriod = "";
      formData.ReversalDate = "";
      formData.IsRepete = isChecked ? 1 : 0;
      isToggleRepeat = isChecked;
      this.setState({ isOpenViewer: false });
    }
    if (FieldType === "reversal") {
      formData.RepeatDate = "No End Date";
      formData.IsReversal = isChecked ? 1 : 0;
      isToggleReversal = isChecked;
    }
    this.setState(
      {
        formData,
        isToggleRepeat,
        isToggleReversal,
        defaultReversalAcPeriod,
        isUpdateRecord: false,
        newRequest: false,
        selectedRepeatType: FieldType === "repeat" ? "Monthly" : this.state.selectedRepeatType,
      },
      () => {
        if (isToggleReversal) {
          formData.IsRepete = 0;
          isToggleRepeat = false;
        }
        if (isToggleRepeat) {
          formData.IsReversal = 0;
          isToggleReversal = false;
        }
        this.setState({
          formData,
          isToggleRepeat,
          isToggleReversal,
          defaultReversalAcPeriod,
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
        });
      }
    );
  };

  handleKeyDown = (event, type) => {
    if (event.key.toLowerCase() === "enter") {
      if (type === "droparea") {
        $("div[id^='" + "droparea" + "']").focus();
      } else {
        this.setState({
          createOther: !event.target.checked,
          isUpdateRecord: false,
          newRequest: false,
        });
      }
    }
    if (event.key.toLowerCase() === "tab") {
      if (type === "droparea") {
        $("checkbox[id^='" + "chkAnother" + "']").focus();
      }
    }
  };

  handleChange = (event: any, FieldType: string) => {
    let formData = { ...this.state.formData };
    if (FieldType === "endDate") {
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();
      formData.RepeatDate = dateNew;
    } else if (FieldType === "notes") {
      formData.Internalnotes = event.target.value;
    } else if (FieldType === "trDate") {
      let isDate = event === null ? Utils.getHotalCurrentDate() : event;
      let today = new Date(isDate);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();
      if (
        this.props
          .isFromRepeating /*&& new Date(dateNew) < new Date(this.state.oldTranDate)*/
      ) {
        //let selDate = today.getDate();
        let selMon = today.getMonth() + 1;
        let selYear = today.getFullYear();

        let curDate = Utils.getHotalCurrentDate().getDate();
        let curMon = Utils.getHotalCurrentDate().getMonth() + 1;
        let curYear = Utils.getHotalCurrentDate().getFullYear();

        let posDate = new Date(this.state.oldTranDate).getDate();
        //let posMon = new Date(this.state.oldTranDate).getMonth() + 1;
        //let posYear = new Date(this.state.oldTranDate).getFullYear();
        if (new Date(this.state.oldTranDate) > Utils.getHotalCurrentDate()) {
          if (
            new Date(this.state.oldTranDate) >
            new Date(curMon + "/" + curDate + "/" + curYear)
          ) {
            if (
              new Date(dateNew) <
                new Date(curMon + "/" + curDate + "/" + curYear) ||
              new Date(selMon + "/" + posDate + "/" + selYear) <
                Utils.getHotalCurrentDate()
            ) {
              Utils.toastError(
                "While editing an existing repeating entry, Post date should be greater or equal to the current date.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                }
              );
              return;
            } else {
              formData.Date = dateNew;
              this.setState({ formData });
            }
          }
        } else if (
          new Date(this.state.oldTranDate) < Utils.getHotalCurrentDate()
        ) {
          let curMonthName = Utils.getHotalCurrentDate().toLocaleString(
            "default",
            { month: "long" }
          );
          let seleMonthName = new Date(dateNew).toLocaleString("default", {
            month: "long",
          });
          if (
            new Date(seleMonthName + "-" + selYear) <=
            new Date(curMonthName + "-" + curYear)
          ) {
            Utils.toastError(
              "While editing an existing repeating entry, Post date should be greater or equal to the transaction date.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
              }
            );
            formData.Date = this.state.formData.Date;
            this.setState({ formData });
            return;
          } else {
            formData.Date = dateNew;
            this.setState({ formData });
          }
        }
        // if(new Date(dateNew) > new Date(curMon+'/'+curDate+'/'+curYear) || new Date(selMon+'/'+posDate+'/'+selYear) < new Date()){
        //     Utils.toastError("While editing an existing repeating entry, Post date should be greater or equal to the current date.", {
        //              position: toast.POSITION.BOTTOM_RIGHT,
        //     });
        //     return;
        // }

        // if(new Date(dateNew).toLocaleDateString() < new Date(this.state.oldTranDate).toLocaleDateString()){

        // }
        // if(new Date(dateNew).toLocaleDateString() < new Date().toLocaleDateString()){
        //   Utils.toastError("While editing an existing repeating entry, Post date should be greater or equal to the current date.", {
        //     position: toast.POSITION.BOTTOM_RIGHT,
        //    });
        //    formData.Date = this.state.formData.Date;
        //    this.setState({ formData })
        //   return;
        // } else {
        //     formData.Date = dateNew;
        //     this.setState({ formData })
        // }
      } else {
        formData.Date = dateNew;
      }
    } else if (FieldType === "revDate") {
      let isDate = event === null ? this.state.defaultReversalAcPeriod : event;
      let today = new Date(isDate);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear();
      formData.ReversalDate = dateNew;
    } else if (FieldType === "createOther") {
      this.setState({ createOther: event.target.checked });
    }
    this.setState({ formData, isUpdateRecord: false, newRequest: false });
  };

  handleNewRow = () => {
    let splitData: any = [];
    let newRow: any = {};
    splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );

    // this.setState({ splitData, isUpdateRecord: false, newRequest: false, }, () => {
    //     if (splitData.length === (rowIndex + 1)) {
    //         if (splitData[rowIndex].coa !== "" && (Number(splitData[rowIndex].credit) !== 0 || Number(splitData[rowIndex].debit) !== 0)) {
    //             this.handleNewRow();
    //         }
    //     }
    // });
    //let newRowError = false;

    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));
    let len = splitData.length;
    let maxRno = splitData[len - 1].rno;
    let maxSrno = splitData[len - 1].srno;
    newRow.rno = Number(maxRno) + 1;
    newRow.srno = Number(maxSrno) + 1;
    newRow.IsCOAPer = "yes";
    splitData.push(newRow);
    this.setState({ splitData: [] }, () => {
      this.setState(
        { splitData: splitData, isUpdateRecord: false, newRequest: false },
        () => {
          let newlen = splitData.length;
          let txtID =
            "rbt-input-main form-control rbt-input coa" +
            (newlen - 1).toString();
          setTimeout(() => {
            $("input[class^='" + txtID + "']").focus();
          }, 50);
        }
      );
    });
    this.addTotalAmount(splitData);
  };

  endDatefocousOut(value) {
    let formData = { ...this.state.formData };
    if (value === "") {
      formData.RepeatDate = "No End Date";
      this.setState({ formData, isUpdateRecord: false, newRequest: false });
    }
  }

  handleSelectedItem = (control: any, id: any) => {
    let formData = { ...this.state.formData };
    let { revAccPeriodList, defaultReversalAcPeriod } = this.state;

    let controlID = Number(control.split("_")[0]);
    let rowIndex = Number(control.split("_")[1]);
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (controlID === 2) {
      // COA
      if (id.length > 0) {
        if (id[0].id > 0) {
          splitData[rowIndex].coaName = id[0].coAname;
          splitData[rowIndex].coa = id[0].id.toString();
          splitData[rowIndex].defaultCoa = id;
          splitData[rowIndex].coaError = "";
          splitData[rowIndex].isCOA = "Yes";
        } else {
          splitData[rowIndex].coaName = "";
          splitData[rowIndex].coa = "";
          splitData[rowIndex].defaultCoa = [];
          splitData[rowIndex].coaError = "";
          splitData[rowIndex].isCOA = "Yes";
        }
      } else {
        splitData[rowIndex].coaName = "";
        splitData[rowIndex].coa = "";
        splitData[rowIndex].defaultCoa = [];
        splitData[rowIndex].coaError = "";
        splitData[rowIndex].isCOA = "Yes";
      }
      if (
        Number(splitData[rowIndex].credit) === 0 &&
        Number(splitData[rowIndex].debit) === 0
      ) {
        splitData[rowIndex].credit = "0.00";
        splitData[rowIndex].debit = "0.00";
      }
      this.setState({ splitData }, () => {
        let txtID =
          "rbt-input-main form-control rbt-input coa" + rowIndex.toString();
        $("#tblSplit")
          .find("input[class^='" + txtID + "']")
          .focus();
      });
    } else if (controlID === 3) {
      let revAccPer = this.getReversalACPer(revAccPeriodList, id);
      formData.AcPeriod = id;
      formData.ReversalAcPeriod = revAccPer;
      formData.ReversalDate = revAccPer;
      if (this.state.oldAcPer === id && this.state.isNeedToChange) {
        this.setState({ isSplitUpdated: "No" });
      } else {
        this.setState({ isSplitUpdated: "Yes" });
      }
      this.setState({
        formData,
        defaultReversalAcPeriod1: revAccPer,
        defaultReversalAcPeriod: revAccPer,
      });
    } else if (controlID === 4) {
      formData.ReversalAcPeriod = id;
      //formData.ReversalDate = id;
      this.setState(() => ({
        formData,
        defaultReversalAcPeriod1: id,
        defaultReversalAcPeriod: id,
      }));
    } else {
    }
    this.setState({ formData, isUpdateRecord: false, newRequest: false });
  };

  updateVendorList = (result: any) => {
    this.setState({ vendorList: result, isSpinner: false });
  };

  handleVendorChange = (vendor: any) => {
    let { formData, selectedVendor, requestlist } = this.state;
    if (vendor.length > 0) {
      requestlist.Vid = vendor[0].vid;
      formData.Vid = vendor[0].vid;
      formData.vendorName = vendor[0].vendorName;
      formData.contract = vendor[0].accountNo;
      selectedVendor = vendor;
      this.setState({
        formData,
        requestlist,
        selectedVendor,
        isUpdateRecord: false,
        newRequest: false,
        isComment: true,
      });
    } else {
      formData.Vid = 0;
      formData.vendorName = "";
      selectedVendor = vendor;
      formData.ReversalAcPeriod = "";
      formData.ReversalDate = "";
      formData.IsReversal = 0;
      formData.IsRepete = 0;
      //setTimeout(() => {
      this.setState({
        isToggleRepeat: this.props?.isFromRepeating ? true : false,
        isToggleReversal: false,
        formData,
        selectedVendor,
        isPreviousTransactions: false,
        isUpdateRecord: false,
        newRequest: false,
        // isComment:false
      });
      //}, 100)
    }
  };

  ishandleDeleteRow = (row: any, mode: any) => {
    if (mode) {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      this.setState({ splitData: [] }, () => {
        this.setState(
          {
            splitData: splitData.filter((item) => item.rno !== row.rno),
            isUpdateRecord: false,
            newRequest: false,
          },
          () => {
            this.addTotalAmount(this.state.splitData);
          }
        );
      });
    }
  };

  addTotalAmount(splitData: any[]) {
    let formData = { ...this.state.formData };
    let splitData1 = Object.assign([], JSON.parse(JSON.stringify(splitData)));
    let splitData2 = Object.assign([], JSON.parse(JSON.stringify(splitData)));
    let totalCreditAmount: string = "0";
    let totalDebitAmount: string = "0";
    formData.TransTotal = "";
    splitData1.forEach((element) => {
      element.credit =
        Utils.removecurrencyFormat(element.credit) === "."
          ? "0.00"
          : Utils.removecurrencyFormat(element.credit);
      element.credit =
        Utils.removecurrencyFormat(element.credit) === ""
          ? 0
          : Utils.removecurrencyFormat(element.credit);
      totalCreditAmount = Number(
        Number(totalCreditAmount) + Number(element.credit)
      ).toString();
    });
    splitData2.forEach((element) => {
      element.debit =
        Utils.removecurrencyFormat(element.debit) === "."
          ? "0.00"
          : Utils.removecurrencyFormat(element.debit);
      element.debit =
        Utils.removecurrencyFormat(element.debit) === ""
          ? 0
          : Utils.removecurrencyFormat(element.debit);
      totalDebitAmount = Number(
        Number(totalDebitAmount) + Number(element.debit)
      ).toString();
    });
    let totalAmount;
    totalAmount = Number(totalDebitAmount) - Number(totalCreditAmount);
    if (
      Number(totalDebitAmount).toFixed(2) ===
      Number(totalCreditAmount).toFixed(2)
    ) {
      let totalDrAmnt =
        Number(totalDebitAmount) !== 0 ? Number(totalDebitAmount) : 0;
      let totalCrAmnt =
        Number(totalDebitAmount) !== 0 ? Number(totalDebitAmount) : 0;
      let totalTrAmount =
        totalDrAmnt != 0 ? totalDrAmnt : totalCrAmnt !== 0 ? totalCrAmnt : 0;
      formData.TransTotal = totalTrAmount;
      totalAmount = 0;
    }
    this.setState({
      totalDebitAmount,
      totalCreditAmount,
      transTotalAmount: Number(totalAmount).toFixed(2),
      formData,
      //isUpdateRecord: false,
      //newRequest: false,
    });
  }

  updateState = (e: any, row, index: any, type: any, txtID) => {
    let start = e.target.selectionStart;
    let end = e.target.selectionEnd;
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let inputVal = e.target.value;
    if (type === "description") {
      splitData[index].description = inputVal;
      splitData[index].isDescription = "Yes";
      this.setState(
        { splitData, isUpdateRecord: false, newRequest: false },
        () => {
          //$("#tblSplit").find("input[id^='" + txtID + "']").focus();
          $("#" + txtID).focus();
          let txtdesc = $("#tblSplit").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      );
    } else if (type === "credit") {
      // inputVal = e.target.value.replace(/[@\/\\^\/\\&\/\\#,+()$~%'":*?<>{}-]/g, '').trim()
      let newVal = Utils.removeInvaildCharFromAmountNonMinus(e.target.value);
      e.target.value = newVal;
      inputVal = e.target.value;
      if (!isNaN(inputVal)) {
        if (inputVal.includes(".")) {
          if (inputVal > 0) {
            splitData[index].debit = "0.00";
          } else {
            splitData[index].debit = "0.00";
          }
          const timeArray = inputVal?.split(".");
          if (timeArray[0].length <= 8 && timeArray[1].length <= 2) {
            splitData[index].credit =
              inputVal === ""
                ? ""
                : !isNaN(inputVal)
                ? inputVal
                : splitData[index].amount;
          }
        } else {
          if (inputVal > 0) {
            splitData[index].debit = "0.00";
          } else {
            splitData[index].debit = "0.00";
          }
          if (inputVal.length <= 8) {
            splitData[index].credit =
              inputVal === ""
                ? ""
                : !isNaN(inputVal)
                ? inputVal
                : splitData[index].amount;
          }
        }
      } else if (inputVal.includes(".") && inputVal.length === 1) {
        if (inputVal > 0) {
          splitData[index].debit = "0.00";
        } else {
          splitData[index].debit = "0.00";
        }
        splitData[index].credit = inputVal;
      }
      this.setState(
        { splitData, isUpdateRecord: false, newRequest: false },
        () => {
          $("#tblSplit")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtamt = $("#tblSplit").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          txtamt.selectionStart = start;
          txtamt.selectionEnd = end;
          this.addTotalAmount(this.state.splitData);
        }
      );
    } else if (type === "debit") {
      // inputVal = e.target.value.replace(/[@\/\\^\/\\&\/\\#,+()$~%'":*?<>{}-]/g, '').trim();
      let newVal = Utils.removeInvaildCharFromAmountNonMinus(e.target.value);
      e.target.value = newVal;
      inputVal = e.target.value;
      if (!isNaN(inputVal)) {
        if (inputVal.includes(".")) {
          if (inputVal > 0) {
            splitData[index].credit = "0.00";
          } else {
            splitData[index].credit = "0.00";
          }
          const timeArray = inputVal?.split(".");
          if (timeArray[0].length <= 8 && timeArray[1].length <= 2) {
            splitData[index].debit =
              inputVal === ""
                ? ""
                : !isNaN(inputVal)
                ? inputVal
                : splitData[index].amount;
          }
        } else {
          if (inputVal > 0) {
            splitData[index].credit = "0.00";
          } else {
            splitData[index].credit = "0.00";
          }
          if (inputVal.length <= 8) {
            splitData[index].debit =
              inputVal === ""
                ? ""
                : !isNaN(inputVal)
                ? inputVal
                : splitData[index].amount;
          }
        }
      } else if (inputVal.includes(".") && inputVal.length === 1) {
        if (inputVal > 0) {
          splitData[index].credit = "0.00";
        } else {
          splitData[index].credit = "0.00";
        }
        splitData[index].debit = inputVal;
      }
      this.setState(
        { splitData, isUpdateRecord: false, newRequest: false },
        () => {
          $("#tblSplit")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtamt = $("#tblSplit").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          txtamt.selectionStart = start;
          txtamt.selectionEnd = end;
          this.addTotalAmount(this.state.splitData);
        }
      );
    }
  };

  amountBlur = (e, rowIndex, type, txtID) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (type === "debit") {
      splitData[rowIndex].debit =
        e.target.value === ""
          ? "0.00"
          : !isNaN(e.target.value)
          ? Utils.currencyFormatWithOutdoller(e.target.value)
          : 0;
    } else {
      splitData[rowIndex].credit =
        e.target.value === ""
          ? "0.00"
          : !isNaN(e.target.value)
          ? Utils.currencyFormatWithOutdoller(e.target.value)
          : 0;
    }
    this.setState({ splitData, newRequest: false });
    //$('#'+ txtID).removeClass("selectAll");
  };

  onSplitAmountFocus = (e, rowIndex, txtID, type) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let newval = Utils.removecurrencyFormat(e.target.value);
    if (type === "debit") {
      splitData[rowIndex].debit = newval;
    } else {
      splitData[rowIndex].credit = newval;
    }
    this.setState({ splitData }, () => {
      $("#tblSplit")
        .find("input[id^='" + txtID + "']")
        .focus();
    });
    // debugger
    // if (!$('#'+ txtID).hasClass('selectAll')) {
    //     let el: any = document.getElementById(txtID);
    //     if (el !== null && el !== undefined) {
    //         setTimeout(() => {
    //             el.select();
    //             $('#'+ txtID).addClass("selectAll");
    //         }, 0);
    //     }
    // }
  };

  handleOutsideClick = (rowIndex: any, e: any) => {
    let btnId = "COA" + rowIndex + "btn";
    let id = "coa" + rowIndex + "ddl";
    let relatedTargetID = e.relatedTarget?.id;

    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    if (splitData[rowIndex].coaName.length === 0) {
      splitData[rowIndex].coaName = "";
      splitData[rowIndex].coa = "";
      splitData[rowIndex].defaultCoa = [];
      splitData[rowIndex].isCOA = "No";
      this.setState({ splitData: [] }, () =>
        this.setState({ splitData }, () => {
          if (relatedTargetID === undefined) {
            //nothing
          } else if (relatedTargetID.includes("ddlEHID")) {
            let btnID = "ddlEHID" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("COA")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("btndesc")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else {
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          }
        })
      );
    } else {
      splitData[rowIndex].isCOA = "No";
      this.setState({ splitData: [] }, () =>
        this.setState({ splitData }, () => {
          if (relatedTargetID === undefined) {
            //nothing
          } else if (relatedTargetID.includes("ddlEHID")) {
            let btnID = "ddlEHID" + rowIndex + "ddl";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("COA")) {
            let txtID1 = "txtamt" + rowIndex + "txt";
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else if (relatedTargetID.includes("btndesc")) {
            $("#tblSplit")
              .find("button[id^='" + relatedTargetID + "']")
              .focus();
          } else {
            $("#tblSplit")
              .find("input[id^='" + relatedTargetID + "']")
              .focus();
          }
        })
      );
    }

    // $("#tblSplit").find("button[id^='" + btnId + "']").css("display", 'block');
    // $("#tblSplit").find("div[id^='" + id + "']").css("display", 'none');
  };

  handleBlur = (event, rowIndex) => {
    if (event.key.toLowerCase() === "tab") {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      splitData[rowIndex].credit =
        event.target.value === ""
          ? ""
          : !isNaN(event.target.value)
          ? Number(event.target.value).toFixed(2)
          : 0;
      this.setState(
        { splitData, isUpdateRecord: false, newRequest: false },
        () => {
          if (splitData.length === rowIndex + 1) {
            //if (/*splitData[rowIndex].coa !== "" || */Number(splitData[rowIndex].credit) !== 0 || Number(splitData[rowIndex].debit) !== 0) {
            //this.handleNewRow();
            //}
          }
        }
      );
    }
  };

  renderMenuItemChildren(option, props, index) {
    return (
      <>
        <div key={option.id}>
          <div className="vendor-name">
            <EllipsisWithTooltip placement="bottom">
              {option.label}
            </EllipsisWithTooltip>
          </div>
          <div className="contracts">{option.accountNo}</div>
        </div>
      </>
    );
  }

  renderCOAItemChildren(option, props, index) {
    return (
      <>
        <div key={option.id}>
          <div className="vendor-name">
            <EllipsisWithTooltip placement="bottom">
              {option.label}
            </EllipsisWithTooltip>
          </div>
        </div>
      </>
    );
  }

  showHideChangeLogModal = () => {
    this.setState({
      showChangeLogModal: !this.state.showChangeLogModal,
    });
  };

  resetState = () => {
    this.setState(
      {
        htmlcomment: [],
        isComment: false,
        isToggleRepeat: false,
        isToggleReversal: false,
        createOther: false,
        alertModalshow: false,
        savedfiles: [],
        files: [],
        isOpenViewer: false,
        newSelectedfiles: [],
        coaList: [],
        totalCreditAmount: 0.0,
        totalDebitAmount: 0.0,
        transTotalAmount: 0.0,
        vendorList: [],
        accPeriodList: [],
        revAccPeriodList: [],
        tabEnable: 0,
        tabDisable: -1,
        totalCount: 0,
        isPreviousTransactions: false,
        isDisabled: false,
        defaultaccountingPeriod: "Accounting Period",
        defaultReversalAcPeriod1: "Accounting Period",
        defaultReversalAcPeriod: "Accounting Period",
        defaultReversalDate: this.state.defaultReversalDate,
        previousTransactionsData: [],
        isChangeJE: this.state.isChangeJE,
        splitData: [
          {
            rno: 1,
            coa: "",
            coaName: "",
            defaultCoa: [],
            description: "",
            debit: "",
            credit: "",
            isCOA: "No",
            isDescription: "No",
          },
          {
            rno: 2,
            coa: "",
            coaName: "",
            defaultCoa: [],
            description: "",
            debit: "",
            credit: "",
            isCOA: "No",
            isDescription: "No",
          },
        ],
        newRow: {
          rno: 1,
          coa: "",
          coaName: "",
          defaultCoa: [],
          description: "",
          debit: "",
          credit: "",
          isCOA: "No",
          isDescription: "No",
        },
        formData: {
          tenantID: 0,
          UniqueNo: 0,
          Vid: this.state.formData.Vid,
          contract: this.state.formData.contract,
          vendorName: this.state.formData.vendorName,
          BackHid: this.state.formData.BackHid,
          Date: "",
          AcPeriod: "",
          TransTotal: 0,
          Internalnotes: "",
          IsReversal: 0,
          ReversalDate: "",
          ReversalAcPeriod: "",
          LoginUser: "",
          IsRepete: 0,
          RepeatDate: "No End Date",
          accPeriodstatus: "Active",
          concilestatus: "No",
        },
      },
      () => {
        this.setState({ isComment: true });
        let vendorReg: any = {};
        vendorReg.hotelID = this.state.requestlist.hotelID;
        let coaRequest: any = {};
        coaRequest.hotelID = this.state.requestlist.hotelID;
        // this.vendorSearch?.current.GetVendorTranlist(vendorReg);   /* Added/Commented to improve speed of Journal Slideout */
        this.reCallApis();
        this.GetHotelCOAlist(coaRequest);
      }
    );
  };

  GetPreviousTransactionList = (request) => {
    request.vid = this.state.formData.vendorID;
    Journalsevice.GetPreviousTransactionList(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          let totalCount = 0;
          if (result.length > 0) {
            totalCount = result[0].totalCount;
          }
          this.setState({ previousTransactionsData: result, totalCount });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reject();
      });
  };

  Previoustransactions = () => {
    this.setState((prevState) => ({
      isPreviousTransactions: !prevState.isPreviousTransactions,
    }));
    let requestlist = { ...this.state.requestlist };
    requestlist.recordCount = 5;
    this.GetPreviousTransactionList(requestlist);
    this.setState({ requestlist, previousTransactionsData: [] });
  };

  loadPreviousData = () => {
    let requestlist = { ...this.state.requestlist };
    let loadrecord = requestlist.recordCount;
    requestlist.recordCount = Number(requestlist.recordCount) + 5;
    if (Number(loadrecord) < Number(this.state.totalCount)) {
      this.GetPreviousTransactionList(requestlist);
      this.setState({ requestlist });
    } else {
      Utils.toastError("No more records found.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
    }
  };

  checkACM = (startDate, endDate) => {
    let { accPeriodList } = this.state;
    let cDate;
    let firstDay;
    let dateArray: any = [];
    let hasinM1: any = [];
    let fDm1: any = [];
    let hasAm1 = false;
    while (startDate <= endDate) {
      cDate = new Date(startDate);
      firstDay = new Date(
        cDate.getFullYear(),
        cDate.getMonth(),
        1
      ).toLocaleDateString();
      dateArray.push(firstDay);
      startDate.setUTCDate(startDate.getUTCDate() + 31);
    }
    for (let i = 0; i < accPeriodList.length; i++) {
      fDm1.push(new Date(accPeriodList[i].name).toLocaleDateString());
    }
    for (let k = 0; k < dateArray.length; k++) {
      hasinM1.push(fDm1.filter((items) => items === dateArray[k]));
    }
    for (let i = 0; i < hasinM1.length; i++) {
      if (hasinM1[i].length === 0) {
        hasAm1 = true;
        break;
      }
    }
    if (hasAm1) {
      return true;
    }
  };

  checkValidation = (formData: any, splitData: any) => {
    let { totalCreditAmount, totalDebitAmount, transTotalAmount } = this.state;
    let JEResponse = "";
    let todaysDate = new Date();
    todaysDate.setHours(0, 0, 0, 0);
    if (formData.IsRepete === 1) {
      let reqDate = new Date(formData.Date);
      let reqEndDate = new Date(formData.RepeatDate);
      if (formData.Date === "") {
        JEResponse = "Please select transaction date.";
        return JEResponse;
      } else if (formData.RepeatDate !== "") {
        if (reqEndDate <= reqDate) {
          JEResponse = "End Date should be greater than Transaction Date.";
          return JEResponse;
        } else {
          let tM = new Date(formData.Date).getMonth() + 1;
          let tY = new Date(formData.Date).getFullYear();
          let accPer = tM + "/01/" + tY;
          let startDate = new Date(accPer);
          let reqEndDate = new Date(formData.RepeatDate);
          let tM2 = new Date(todaysDate).getMonth() + 1;
          let tY2 = new Date(todaysDate).getFullYear();
          let todaysDate2 = tM2 + "/01/" + tY2;
          let endDate =
            reqEndDate > new Date(todaysDate2)
              ? new Date(todaysDate2)
              : reqEndDate;
          let hasACM = this.checkACM(startDate, endDate);
          if (hasACM) {
            let trResponse =
              "All the accounting periods from the selected date till current date should be active.";
            return trResponse;
          }
        }
      } else {
        let tM = new Date(formData.Date).getMonth() + 1;
        let tY = new Date(formData.Date).getFullYear();
        let accPer = tM + "/01/" + tY;
        let startDate = new Date(accPer);
        let tM2 = new Date(todaysDate).getMonth() + 1;
        let tY2 = new Date(todaysDate).getFullYear();
        let todaysDate2 = tM2 + "/01/" + tY2;
        let endDate = new Date(todaysDate2);
        if (new Date(startDate).getMonth() + 1 <= new Date().getMonth() + 1) {
          let hasACM = this.checkACM(startDate, endDate);
          if (hasACM) {
            let trResponse =
              "All the accounting periods from the selected date till current date should be active.";
            return trResponse;
          }
        }
      }
    }
    if (formData.IsReversal === 1) {
      if (formData.ReversalAcPeriod === "") {
        JEResponse = "Please select reversal acccounting period.";
        return JEResponse;
      }
      if (formData.ReversalDate === "") {
        JEResponse = "Please select reversal date.";
        return JEResponse;
      }
    }
    if (formData.IsRepete === 0) {
      if (formData.Date === "") {
        JEResponse = "Please enter the transaction date.";
        return JEResponse;
      }
    }
    for (let i = 0; i < splitData.length; i++) {
      if (splitData.length == 2) {
        if (splitData[i].coa === "") {
          splitData[i].coaError = "hasError";
          this.setState({ splitData });
          JEResponse = "Please select COA.";
          return JEResponse;
        } else if (
          Number(splitData[i].credit) === 0 &&
          Number(splitData[i].debit) === 0
        ) {
          JEResponse = "Please enter debit or credit amount.";
          return JEResponse;
        } else if (
          transTotalAmount !== "0.00" &&
          Number(splitData[i].credit) === 0 &&
          Number(splitData[i].debit) === 0
        ) {
          JEResponse = "Please enter a valid Debit and Credit amounts.";
          return JEResponse;
        }
      } else {
        if (
          Number(splitData[i].credit) === 0 &&
          Number(splitData[i].debit) === 0 &&
          splitData[i].coa === ""
        ) {
          JEResponse = "";
          //return JEResponse;
        } else if (
          transTotalAmount === "0.00" &&
          (Number(splitData[i].credit) !== 0 ||
            Number(splitData[i].debit) !== 0) &&
          splitData[i].coa === ""
        ) {
          splitData[i].coaError = "hasError";
          this.setState({ splitData });
          JEResponse = "Please select COA.";
          return JEResponse;
        } else if (transTotalAmount === "0.00" && splitData[i].coa === "") {
          splitData[i].coaError = "hasError";
          this.setState({ splitData });
          JEResponse = "Please select COA.";
          return JEResponse;
        }
        // else if (Number(splitData[i].credit) === 0 && Number(splitData[i].debit) === 0) {
        //     JEResponse = "Please enter debit or credit amount.";
        //     return JEResponse;
        // }
      }
    }
    if (Number(totalCreditAmount) === 0 && Number(totalDebitAmount) === 0) {
      JEResponse = "Please enter a valid Debit and Credit amounts.";
      return JEResponse;
    }
    if (
      Utils.currencyFormat(totalCreditAmount) !=
      Utils.currencyFormat(totalDebitAmount)
    ) {
      JEResponse = "Debit and credit amounts are not equal.";
      return JEResponse;
    }
    if (JEResponse === "") {
      JEResponse = "Valid";
      return JEResponse;
    }
  };

  saveFormResponse = () => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let formData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.formData))
    );
    let JERequests: any = {};
    JERequests.UniqueNo = formData.UniqueNo;
    JERequests.Vid = formData.Vid;
    JERequests.BackHid = formData.BackHid;
    JERequests.Date = formData.Date;
    JERequests.AcPeriod = formData.AcPeriod;
    JERequests.TransTotal = Utils.removecurrencyFormat(formData.TransTotal); //formData.TransTotal;
    JERequests.Internalnotes = formData.Internalnotes;
    JERequests.IsReversal = formData.IsReversal;
    JERequests.ReversalDate = formData.ReversalDate;
    JERequests.ReversalAcPeriod = formData.ReversalAcPeriod;
    JERequests.LoginUser = formData.LoginUser;
    JERequests.IsRepete = formData.IsRepete;
    JERequests.RepeatDate = formData.RepeatDate;
    JERequests.Contract = formData.contract;
    JERequests.iscopyAttachment = formData.iscopyAttachment;
    JERequests.actionType = formData.actionType;
    JERequests.isSplitUpdated = this.state.isSplitUpdated;
    let JournalDF: any = []; //Debit
    let JournalDT: any = []; //Credit
    for (let i = 0; i < splitData.length; i++) {
      if (splitData[i].debit !== "0.00" || splitData[i].credit !== "0.00") {
        if (Number(splitData[i].coa) !== 0) {
          if (Number(splitData[i].debit) !== 0) {
            JournalDF.push({
              COA: splitData[i].coa.toString(),
              COAName: splitData[i].coaName,
              Description: splitData[i].description,
              //Amount: Number(splitData[i].debit),
              Amount: Utils.removecurrencyFormat(splitData[i].debit),
            });
          } else {
            JournalDT.push({
              COA: splitData[i].coa.toString(),
              COAName: splitData[i].coaName,
              Description: splitData[i].description,
              // Amount: Number(splitData[i].credit),
              Amount: Utils.removecurrencyFormat(splitData[i].credit),
            });
          }
        }
      }
    }
    JERequests.JournalDF = JournalDF;
    JERequests.JournalDT = JournalDT;
    let isRepRev = this.state.isToggleReversal || this.state.isToggleRepeat;
    JERequests.TempUniqueNo = this.state.isToggleRepeat
      ? this.state.tempUniqueNo
      : this.state.slideEntryType === "newEntry"
      ? isRepRev
        ? ""
        : this.state.tempUniqueNo
      : "";
    JERequests.OldpageType =
      this.state.slideEntryType === "newEntry" ? "TempUploadFiles" : "Journal";
    return JERequests;
  };

  alertModalShow = () => {
    this.setState({ alertModalshow: true });
  };
  alertModalHide = () => {
    this.setState({ alertModalshow: false, isDisabled: false });
  };
  saveDepositeEntry = () => {
    this.setState({ alertModalshow: false });
    this.saveJRForm(this.saveFormResponse(), this.state.files);
  };
  SaveJournalEntry = () => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    let formData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.formData))
    );
    let JEResponse = this.checkValidation(formData, splitData);

    if (this.ChildComment.current?.isCommentAdd()) {
      Utils.toastError("Please add your comments.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
      return false;
    }

    if (JEResponse !== "" && JEResponse !== "Valid") {
      Utils.toastError(JEResponse, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
      return;
    }
    if (JEResponse === "Valid") {
      let todaysDate = Utils.getHotalCurrentDate();
      todaysDate.setHours(0, 0, 0, 0);
      // this.saveJRForm(this.saveFormResponse(), this.state.files)
      if (new Date(this.saveFormResponse().Date) > todaysDate) {
        this.alertModalShow();
      } else {
        this.saveJRForm(this.saveFormResponse(), this.state.files);
      }
    }
  };

  saveJRForm = (JERequests, files) => {
    if (this.state.isSplitUpdated === "No") {
      let updatedsplitlist: any = [];
      JERequests.JournalDF.forEach((element) => {
        element.projectlist = [];
        element.subVendorlist = [];
        let splitlistItem: any = [];

        splitlistItem.coa = element.COA.toString();
        //splitlistItem.spiltHoteID = element.spiltHoteID;
        //splitlistItem.subVID = element.subVID;
        //splitlistItem.pID = element.pID;
        splitlistItem.description = element.Description;
        splitlistItem.dr = element.Amount;
        splitlistItem.cr = "0.00";
        updatedsplitlist.push(splitlistItem);
      });

      JERequests.JournalDT.forEach((element) => {
        element.projectlist = [];
        element.subVendorlist = [];
        let splitlistItem: any = [];

        splitlistItem.coa = element.COA.toString();
        //splitlistItem.spiltHoteID = element.spiltHoteID;
        //splitlistItem.subVID = element.subVID;
        //splitlistItem.pID = element.pID;
        splitlistItem.description = element.Description;
        splitlistItem.cr = element.Amount;
        splitlistItem.dr = "0.00";
        updatedsplitlist.push(splitlistItem);
      });

      let splitActualList = this.state.splitActualList;

      if (this.state.splitActualList.length !== updatedsplitlist.length) {
        JERequests.isSplitUpdated = "Yes";
      } else {
        updatedsplitlist.forEach((ele, idx) => {
          if (
            (ele.coa !== splitActualList[idx].coa ||
              ele.description.toLowerCase() !==
                splitActualList[idx].description.toLowerCase() ||
              ele.cr !== splitActualList[idx].cr ||
              ele.dr !== splitActualList[idx].dr) &&
            JERequests.isSplitUpdated === "No"
          ) {
            JERequests.isSplitUpdated = "Yes";
          }
        });
      }
    }
    //console.log(JERequests)
    //this.state.isToggleRepeat ? JERequests.UniqueNo :
    this.setState({ isDisabled: true });
    let userComments: any = [];
    userComments = this.ChildComment.current?.CommentToSave();
    JERequests.commentsreq = userComments;
    let { isCopyEntry } = this.state;
    JERequests.UniqueNo = isCopyEntry ? 0 : JERequests.UniqueNo;
    JERequests.actionType = isCopyEntry ? "" : JERequests.actionType;
    JERequests.repeatType = this.state.isToggleRepeat ? this.state.selectedRepeatType : "";
    Journalsevice.SaveJournalEntry(JERequests, files)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.saveStatus === null) {
            Utils.toastError("Something went wrong.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "JESave",
            });
          }

          if (
            result.saveStatus.toString().toLowerCase() ===
            "Success".toLocaleLowerCase()
          ) {
            toast.success(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "JESave",
            });
            this.setState({
              isDisabled: false,
              isCopyEntry: false,
              alertModalshow: false,
              isChangeJE: true,
              isUpdateRecord: true,
              newRequest: false,
            });
            if (!this.state.createOther) {
              setTimeout(() => {
                this.closeSlideOut();
              }, 3000);
            }
            setTimeout(() => {
              this.resetState();
            }, 3500);
          } else if (
            result.message.toString().toLowerCase() ===
            "Trans Date smallar".toLocaleLowerCase()
          ) {
            this.setState({ isDisabled: false });
            Utils.toastError(
              "Transaction date can not be less then the account opening date.",
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "JESave",
              }
            );
          } else if (
            result.message.toString().toLowerCase() ===
            "An unhandled exception occurred".toLocaleLowerCase()
          ) {
            this.setState({ isDisabled: false });
            Utils.toastError("An unhandled exception occurred.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "JESave",
            });
          } else {
            this.setState({ isDisabled: false });
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "JESave",
            });
          }
        }
        else {
          this.setState({ isDisabled: false });
          Utils.toastError("An unhandled exception occurred.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "JESave",
          });
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reject();
      });
  };

  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };

  hasEditAccess = (e) => {
    if (e.keyCode === 9) {
      if (
        this.state.hasEditPermission === false ||
        this.state.isPermission === "No"
      ) {
        e.preventDefault();
      }
    }
  };

  handleDescriptionBlur = (btnID, txtID, rowIndex, e: any) => {
    let relatedTargetID = e.relatedTarget?.id;
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isDescription = "No";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        if (relatedTargetID === undefined) {
          //nothing
        } else if (relatedTargetID.includes("ddlEHID")) {
          let btnID = "ddlEHID" + rowIndex + "ddl";
          $("#tblSplit")
            .find("button[id^='" + btnID + "']")
            .focus();
        } else if (relatedTargetID.includes("COA")) {
          let txtID =
            "rbt-input-main form-control rbt-input coa" + rowIndex + "ddl";
          let btnID = "COA" + rowIndex + "btn";
          // $("input[class^='" + txtID + "']").focus();
          $("#tblSplit")
            .find("button[id^='" + relatedTargetID + "']")
            .focus();
        } else if (relatedTargetID.includes("btndesc")) {
          $("#tblSplit")
            .find("button[id^='" + relatedTargetID + "']")
            .focus();
        } else {
          let txtID1 = "txtamt" + rowIndex + "txt";
          $("#tblSplit")
            .find("input[id^='" + relatedTargetID + "']")
            .focus();
        }
      })
    );

    //  $("#tblSplit").find("button[id^='" + btnID + "']").css("display", 'block');
    //$("#tblSplit").find("input[id^='" + txtID + "']").css("display", 'none');
  };

  handleDescriptionFocus = (btnID, txtID, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isDescription = "Yes";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        $("#tblSplit")
          .find("input[id^='" + txtID + "']")
          .focus();
      })
    );
  };

  handleCOABlur = (btnID, txtID, ddlID) => {
    $("#tblSplit")
      .find("button[id^='" + btnID + "']")
      .css("display", "block");
    $("#tblSplit")
      .find("div[id^='" + txtID + "']")
      .css("display", "none");
  };

  handleCOAFocus = (btnID, txtID, ddlID, rowIndex) => {
    let splitData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.splitData))
    );
    splitData[rowIndex].isCOA = "Yes";
    this.setState({ splitData: [] }, () =>
      this.setState({ splitData }, () => {
        $("input[class^='" + ddlID + "']").focus();
      })
    );
  };

  onTAB = (control, event) => {
    if (event.key.toLowerCase() === "tab") {
      let controlID = control.split("-")[0];
      let rowIndex: any = Number(control.split("-")[1]);
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      if (controlID === "txtNotes") {
        //txtNotes-0
        let txtID =
          "rbt-input-main form-control rbt-input coa" + rowIndex.toString();
        setTimeout(() => {
          $("input[class^='" + txtID + "']").focus();
        }, 50);
      } else if (controlID === "debit" && !event.shiftKey) {
        splitData[rowIndex].debit =
          event.target.value === ""
            ? ""
            : !isNaN(event.target.value)
            ? Number(event.target.value).toFixed(2)
            : 0;
        this.setState({ splitData, isUpdateRecord: false, newRequest: false });
      } else if (controlID === "credit" && !event.shiftKey) {
        splitData[rowIndex].credit =
          event.target.value === ""
            ? ""
            : !isNaN(event.target.value)
            ? Number(event.target.value).toFixed(2)
            : 0;
        this.setState(
          { splitData, isUpdateRecord: false, newRequest: false },
          () => {
            if (
              splitData.length === rowIndex + 1 &&
              splitData[rowIndex]["coa"] !== ""
            ) {
              this.handleNewRow();
              let txtID = "COA" + splitData.length.toString() + "btn";
              setTimeout(() => {
                $("#" + txtID).focus();
              }, 50);
            } else {
              let txtID = "coa_" + (rowIndex + 1).toString();
              setTimeout(() => {
                $("#" + txtID).focus();
              }, 50);
            }
          }
        );
      } else if (controlID === "ddlCOA") {
        if (
          rowIndex >= 2 &&
          splitData[rowIndex]["coa"] === "" &&
          !event.shiftKey
        ) {
          // let txtID = "description-" + (rowIndex).toString();
          // setTimeout(() => { $("input[id^='" + txtID + "']").focus() }, 50);
          setTimeout(() => {
            $("#droparea").focus();
          }, 50);
        } else if (
          rowIndex >= 2 &&
          (splitData[rowIndex]["coa"] === "" ||
            splitData[rowIndex]["coa"] !== "") &&
          event.shiftKey
        ) {
          let txtID = "credit-" + (rowIndex - 1).toString() + "credit";
          setTimeout(() => {
            $("input[id^='" + txtID + "']").focus();
          }, 50);
        } else if (
          rowIndex === 0 &&
          (splitData[rowIndex]["coa"] === "" ||
            splitData[rowIndex]["coa"] !== "") &&
          event.shiftKey
        ) {
          setTimeout(() => {
            $("#txtNotes").focus();
          }, 50);
        }
      } else if (controlID === "description" && !event.shiftKey) {
        let txtID = "debit-" + rowIndex.toString() + "debit";
        setTimeout(() => {
          $("#" + txtID).select();
        }, 50);
      }
    }
  };

  openFileViewer = (row: any) => {
    let uniqueNo = row.uniqueNo;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let etype = "Journal"; //this.state.formData.entryType;
    window.open(
      "/MediaViewer?Uniqueno=" +
        btoa(uniqueNo) +
        "&tenantID=" +
        btoa(tenantID) +
        "&Etype=" +
        btoa(etype),
      "_blank"
    );
  };

  /*Viewer Start*/

  handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
    if (chktype === "bulkSelect") {
      if (!event.target.checked) {
        this.setState({ chkIds: [], selectedChk: [] });
      } else {
        const newIds = [...this.state.chkIds];
        files.forEach((element) => {
          for (let inx = 0; inx < element.totalpage; inx++) {
            let id = element.fileNo.toString() + "_" + inx.toString();
            const selectedId1 = `custom_${id}`;
            const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
            if (newId.length === 0) {
              let item: any = {};
              item.id = selectedId1;
              item.fileNo = element.fileNo;
              newIds.push(item);
            }
          }
          this.setState({ chkIds: newIds });
        });
      }
    } else if (chktype === "All") {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.fileNo !== fileNo);
        this.setState({ chkIds: newIds });
        // setchkIds(newIds);
      } else {
        const newIds = [...this.state.chkIds];
        files
          .filter((x) => x.fileNo === fileNo)
          .forEach((element) => {
            for (let inx = 0; inx < element.totalpage; inx++) {
              let id = element.fileNo.toString() + "_" + inx.toString();
              const selectedId1 = `custom_${id}`;
              const newId = this.state.chkIds.filter(
                (x) => x.id === selectedId1
              );
              if (newId.length === 0) {
                let item: any = {};
                item.id = selectedId1;
                item.fileNo = element.fileNo;
                newIds.push(item);
              }
            }
            this.setState({ chkIds: newIds });
            // setchkIds(newIds);
          });
      }
    } else {
      // const selectedId = `custom_${id}`

      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        let item: any = {};
        item.id = selectedId;
        item.fileNo = fileNo;
        newIds.push(item);
        this.setState({ chkIds: newIds });
      }
    }
  };

  hideBulkselect = () => {
    this.setState({ bulkSelect: false, chkIds: [], selectedChk: [] });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  };

  OpenViewer = () => {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        defaultView: "doc-view",
        //fileSelect: this.state.savedfiles.length > 0 ? this.state.savedfiles[0] : this.state.newSelectfiles[0],
      }),
      () => {
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  };

  handleUpdatedFile = () => {
    return this.state.chkIds;
  };

  // adjustMapping = () => {
  //     this.setState({ isMappedShow: true }, () => {
  //         this.pdfExtract();
  //     });
  // }

  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    //console.log("updateZoom-" + updateZoom);
    this.setState({ currentZoom: updateZoom });
  };

  handleAllCheckbox = (event) => {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  };

  handleBulkRotate = () => {
    this.handleRotate(this.state.chkIds, 0, 0);
  };

  handleBulkRemove = () => {
    this.handlePageRemove(this.state.chkIds, 0, 0);
  };

  handleRotate = (chkIds, currentfileNo, currentPage) => {
    let scrollPos = this.scrollheight.current.getElement().scrollTop;
    this.setState({ currentScreenTop: scrollPos });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let selectedRotateFile: any = [];
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : "Journal";
        item.tenantID = this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : "Journal";
        item1.tenantID =
          this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRotation(selectedRotateFile, chkIds);
    } else {
      toast.success("Please select atleast one page to rotate.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
    }
  };

  saveRotation = (request, chkIds) => {
    this.setState({ isSpinner: true });
    registersevice
      .RotatePDf(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            if (request.length === 1) {
              toast.success("Page rotated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveCreditCard",
              });
            } else {
              toast.success("Pages rotated successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "SaveCreditCard",
              });
            }

            this.setState({ selectedChk: chkIds }, () => {
              // this.setState({ selectedChk: [], chkIds: [], bulkSelect: false }, () => {
              this.getUploadedFileList();
              // this.GetPostToInvoice();
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "SaveCreditCard",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  handlePageRemove = (chkIds, currentfileNo, currentPage) => {
    let scrollPos = this.scrollheight.current.getElement().scrollTop;
    this.setState({ currentScreenTop: scrollPos });
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let tenantID = storage === null ? 0 : (storage.tenantID as any);
    let selectedRotateFile: any = [];
    if (chkIds.length > 0) {
      for (let x = 0; x < chkIds.length; x++) {
        let splitchkIds: any = [];
        splitchkIds = chkIds[x].id.toString().split("_");
        let fileNo = Number(splitchkIds[1]);
        let pageNo = Number(splitchkIds[2]) + 1;
        let savedFileDet = this.state.savedfiles.filter(
          (e) => e.fileUniqueno === fileNo
        );
        let item: any = {};
        item.hotelID = this.state.formData.hotelID;
        item.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet[0].uniqueNo;
        item.uploadFile = savedFileDet[0].uploadFile;
        item.fileNo = fileNo;
        item.pageNo = pageNo;
        item.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : "Journal";
        item.tenantID = this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item);
      }
    }
    if (currentfileNo > 0) {
      let isExist = selectedRotateFile.filter(
        (y) => y.fileNo === currentfileNo && y.pageNo === currentPage
      );
      if (isExist.length === 0) {
        let item1: any = {};
        let savedFileDet1 = this.state.savedfiles.filter(
          (e1) => e1.fileUniqueno === currentfileNo
        );
        item1.hotelID = this.state.formData.hotelID;
        item1.uniqueNo =
          this.state.slideEntryType === "newEntry"
            ? this.state.tempUniqueNo
            : savedFileDet1[0].uniqueNo;
        item1.uploadFile = savedFileDet1[0].uploadFile;
        item1.fileNo = currentfileNo;
        item1.pageNo = currentPage;
        item1.etype =
          this.state.slideEntryType === "newEntry"
            ? "TempUploadFiles"
            : "Journal";
        item1.tenantID =
          this.state.slideEntryType === "newEntry" ? 0 : tenantID;
        selectedRotateFile.push(item1);
      }
    }
    if (selectedRotateFile.length > 0) {
      this.saveRemovepage(selectedRotateFile, chkIds);
    } else {
      toast.success("Please select atleast one page to remove.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "JESave",
      });
    }
  };

  saveRemovepage = (request, chkIds) => {
    this.setState({ isSpinner: true });
    registersevice
      .RemovePDFPage(request)
      .then(async (result: any | null) => {
        this.setState({ isSpinner: false });
        if (result !== null) {
          if (result.saveStatus === "Success") {
            if (request.length === 1) {
              toast.success("Page removed successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "JESave",
              });
            } else {
              toast.success("Pages removed successfully.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "JESave",
              });
            }

            this.setState({ selectedChk: [chkIds], isSave: true }, () => {
              this.getUploadedFileList();
              // this.GetPostToInvoice();
              this.hideBulkselect();
              // setTimeout(() => {
              //     this.setState({ bulkSelect: true })
              //     for (let i = 0; i < this.state.savedfiles.length; i++) {
              //         this["myRef" + i].current.showBulkSelect();
              //     }
              // }, 1000)
            });
          } else {
            Utils.toastError(result.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "JESave",
            });
          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };
  /*Viewer Ends*/

  VendorSearchlistWithKey = (name, HID, vendorSelected) => {
    /* Added/Commented to improve speed of Journal Slideout */

    let request: any = {};
    request.etype = this.props.pageType;
    request.searchKey = name;
    request.hotelID = HID;
    registersevice
      .VendorSearchlistWithKey(request) //Vendor list service method
      .then(async (result: any | null) => {
        if (result !== null) {
          this.vendorSearch?.current.handleArrayFromParent(
            result
          ); /* Added to improve speed of Journal Page */
          this.vendorSearch?.current.handleSelectFromParent(vendorSelected);
        }
        this.setState({ isSpinner: false });
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  onSelectRepeatType = (item) => {
    this.setState({ selectedRepeatType: item.name, isUpdateRecord: false, });
  }

  render() {
    let isFooterDisable =
      this.state.isDisabled ||
      this.state.isUpdateRecord ||
      !this.state.hasEditPermission ||
      this.state.isPermission === "No";

    /*Viewer */
    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate(
        {
          scrollTop: 0,
        },
        500
      );
    };
    const handleUpdate = (newtext) => {
      //this.setState({ defaultView: "doc-view"});
      toggleSwitch("doc-view");
      setTimeout(function () {
        let currentPos: any = $(`#${newtext}`).offset()?.top;
        let marginArea = currentPos - 138;
        $(".scroll-area").animate(
          {
            scrollTop: marginArea,
          },
          500
        );
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      //let docViewerFiles : any =[];
      docViewerFiles.push(docFiles);
      //this.setState({ docViewerFiles: docFiles })
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      if (totalpage === 0) {
        this.footerchk.current.labels[0].innerHTML = "No Page Selected";
      } else if (totalpage === 1) {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Page Selected";
      } else {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Pages Selected";
      }
      if (type === "removeAll") {
        this.footerchk.current.indeterminate = false;
        this.footerchk.current.checked = false;
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };

    const currentView = this.state.defaultView;
    const savedfilesCount = this.state.savedfiles.length;
    const allsavedfiles = this.state.savedfiles;
    let hideZoombtn =
      allsavedfiles.length === 1 &&
      allsavedfiles[0].name
        .split(".")
        .pop()
        .includes("xls".toLocaleLowerCase());
    let NoDelPermission = false;
    /*Viewer */

    let isEnableForUpload = this.state.newSelectedfiles.length > 0;
    const files = this.state.newSelectedfiles.map((file, index) => {
      return (
        <>
          <li key={file.name}>
            <div className="d-flex align-items-center justify-content-start">
              <div className="icon">
                {file?.type?.split("/")[0] === "image" && (
                  <FontAwesomeIcon icon={faFileImage} />
                )}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
                {file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
                {file?.type?.split("/")[0] !== "image" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "pdf" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "xlsx" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "csv" &&
                  file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  ) !== "word" && <FontAwesomeIcon icon={faFile} />}
              </div>
              <div className="file-info d-flex">
                <div className="name-loader">
                  <div className="name d-flex">
                    <div className="full-name">{file.name}</div>
                    {/* <div className="full-size">- {file.size} bytes</div> */}
                  </div>
                  {/* <div className="loader"><ProgressBar animated variant="success" now={45} /></div> */}
                </div>
                <div className="formate-percentage">
                  <div className="formate d-flex justify-content-center align-items-center">
                    {file?.name.substring(
                      file?.name.lastIndexOf(".") + 1,
                      file?.name.length
                    )}
                  </div>
                  {/* <div className="percentage d-flex justify-content-center align-items-center">45%</div> */}
                </div>
              </div>
              <div className="action">
                {this.state.newSelectedfiles.length > 0 ? (
                  <Spinner
                    size="sm"
                    title="Uploading..."
                    animation="border"
                    variant="success"
                  />
                ) : (
                  <Dropdown
                    className="more-action"
                    alignRight
                    onSelect={(event: any) =>
                      this.handleSelectFileUpload(event, file, index)
                    }
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {this.state.moreActionFileUpload.map(
                        (item: any, idx: any) => (
                          <>
                            <Dropdown.Item
                              eventKey={
                                this.state.moreActionFileUpload[idx].eventKey
                              }
                              key={idx}
                            >
                              {this.state.moreActionFileUpload[idx].name}
                            </Dropdown.Item>
                          </>
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </li>
        </>
      );
    });

    const files1 = this.state.savedfiles.map((file, index) => (
      <>
        <li key={file.name}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="icon">
              {file?.type?.split("/")[0] === "image" && (
                <FontAwesomeIcon icon={faFileImage} />
              )}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "pdf" && <FontAwesomeIcon icon={faFilePdf} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "xlsx" && <FontAwesomeIcon icon={faFileExcel} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "csv" && <FontAwesomeIcon icon={faFileCsv} />}
              {file?.name.substring(
                file?.name.lastIndexOf(".") + 1,
                file?.name.length
              ) === "word" && <FontAwesomeIcon icon={faFileWord} />}
              {file?.type?.split("/")[0] !== "image" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "pdf" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "xlsx" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "csv" &&
                file?.name.substring(
                  file?.name.lastIndexOf(".") + 1,
                  file?.name.length
                ) !== "word" && <FontAwesomeIcon icon={faFile} />}
            </div>
            <div className="file-info d-flex">
              <div className="name-loader">
                <div className="name d-flex">
                  <div className="full-name">{file.name}</div>
                  {/* <div className="full-size">- {file.size} bytes</div> */}
                </div>
                {/* <div className="loader"><ProgressBar animated variant="success" now={45} /></div> */}
              </div>
              <div className="formate-percentage">
                <div className="formate d-flex justify-content-center align-items-center">
                  {file?.name.substring(
                    file?.name.lastIndexOf(".") + 1,
                    file?.name.length
                  )}
                </div>
                {/* <div className="percentage d-flex justify-content-center align-items-center">45%</div> */}
              </div>
            </div>
            <div className="action">
              <Dropdown
                className="more-action"
                alignRight
                onSelect={(event: any) =>
                  this.handleSelectFileUpload(event, file, index)
                }
              >
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {this.state.moreActionFileUpload1.map(
                    (item: any, idx: any) => (
                      <>
                        {file.fileUniqueno > 0 && (
                          <Dropdown.Item
                            className={
                              (!this.state.hasEditPermission ||
                                this.state.isPermission === "No") &&
                              this.state.moreActionFileUpload1[idx].eventKey ===
                                "deleteFile"
                                ? "d-none"
                                : ""
                            }
                            eventKey={
                              this.state.moreActionFileUpload1[idx].eventKey
                            }
                            key={idx}
                          >
                            {this.state.moreActionFileUpload1[idx].name}
                          </Dropdown.Item>
                        )}
                      </>
                    )
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </li>
      </>
    ));

    const transactionsColumns = [
      {
        dataField: "coaName",
        text: "COA",
        headerClasses: "coa",
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let btnId = "COA" + rowIndex + "btn";
          let id = "coa" + rowIndex + "ddl";
          const defaultCoa =
            this.state.formData.UniqueNo === 0
              ? row.coa + " " + row.coaName
              : row.coaName;
          return (
            <div
              tabIndex={this.state.tabEnable}
              className={
                this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active"
                  ? ""
                  : "disabled-area"
              }
            >
              <div
                className="more-action single-select-image dropdown coa-select jecoaSelect"
                onWheel={this.hoverOutEllipsis.bind(this)}
              >
                <div
                  id={id}
                  style={
                    row.isCOA === "Yes"
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  className={row.coaError === "hasError" ? "coaHasError" : ""}
                >
                  <Typeahead
                    inputProps={{
                      className: "coa" + rowIndex.toString(),
                      title: defaultCoa,
                      id: "coa_" + rowIndex.toString(),
                    }}
                    id={"coa" + rowIndex}
                    flip={true}
                    placeholder={"Enter COA"}
                    options={this.state.coaList}
                    disabled={
                      row.IsCOAPer?.toLowerCase() === "no" ? true : false
                    }
                    renderMenu={(results: any, menuProps) => (
                      <Menu {...menuProps}>
                        {results.map((result: any, index: any) => (
                          <>
                            {this.state.coaList.length > 0 &&
                              results[index - 1]?.orderno === 1 &&
                              result?.orderno === 2 && <Dropdown.Divider />}
                            <MenuItem option={result} position={index}>
                              <EllipsisWithTooltip placement="bottom">
                                {result.label}
                              </EllipsisWithTooltip>
                            </MenuItem>
                            {result.label == "" && (
                              <MenuItem
                                className="load-more"
                                option={result}
                                position={index}
                              >
                                Load More
                              </MenuItem>
                            )}
                          </>
                        ))}
                      </Menu>
                    )}
                    renderMenuItemChildren={this.renderCOAItemChildren}
                    onChange={this.handleSelectedItem.bind(
                      this,
                      2 + "_" + rowIndex
                    )}
                    selected={row.defaultCoa}
                    onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                    onKeyDown={this.onTAB.bind(
                      this,
                      "ddlCOA-" + rowIndex.toString()
                    )}
                  />
                </div>
                <button
                  className={
                    row.coaName === "" ? "custom-btn placeholder" : "custom-btn"
                  }
                  id={btnId}
                  style={
                    row.isCOA === "Yes"
                      ? { display: "none", width: "100%" }
                      : { display: "block", width: "100%" }
                  }
                  onClick={() => {
                    this.handleCOAFocus(
                      btnId,
                      id,
                      "rbt-input-main form-control rbt-input coa" + rowIndex,
                      rowIndex
                    );
                  }}
                  onFocus={() => {
                    this.handleCOAFocus(
                      btnId,
                      id,
                      "rbt-input-main form-control rbt-input coa" + rowIndex,
                      rowIndex
                    );
                  }}
                >
                  {row.coaName === "" && (
                    <EllipsisWithTooltip placement="bottom">
                      {"Enter COA"}
                    </EllipsisWithTooltip>
                  )}
                  {row.coaName !== "" && (
                    <EllipsisWithTooltip placement="bottom">
                      {defaultCoa}
                    </EllipsisWithTooltip>
                  )}
                </button>
              </div>
            </div>
          );
        },
      },
      {
        dataField: "description",
        text: "Description",
        headerClasses: "description",
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "description-" + rowIndex.toString();
          let btnId = "btndesc" + rowIndex + "btn";
          return (
            <div
              className={
                this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active"
                  ? ""
                  : "disabled-area"
              }
            >
              <div className="more-action single-select-image dropdown coa-select">
                <Form.Control
                  style={
                    row.isDescription === "Yes"
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  tabIndex={this.state.tabEnable}
                  maxLength={99}
                  id={id}
                  name="description"
                  type="text"
                  value={row.description}
                  placeholder="Enter Description"
                  autoComplete="off"
                  onChange={(e) =>
                    this.updateState(e, row, rowIndex, "description", id)
                  }
                  onBlur={(e) => {
                    this.handleDescriptionBlur(btnId, id, rowIndex, e);
                  }}
                  disabled={row.IsCOAPer?.toLowerCase() === "no" ? true : false}
                  onKeyDown={this.onTAB.bind(
                    this,
                    "description-" + rowIndex.toString()
                  )}
                />

                <button
                  className={
                    row.description === ""
                      ? "custom-btn placeholder"
                      : "custom-btn"
                  }
                  id={btnId}
                  style={
                    row.isDescription === "Yes"
                      ? { display: "none", width: "100%" }
                      : { display: "block", width: "100%" }
                  }
                  onClick={() => {
                    this.handleDescriptionFocus(btnId, id, rowIndex);
                  }}
                  onFocus={() => {
                    this.handleDescriptionFocus(btnId, id, rowIndex);
                  }}
                >
                  {row.description === "" && (
                    <EllipsisWithTooltip placement="bottom">
                      {"Enter Description"}
                    </EllipsisWithTooltip>
                  )}
                  {this.props.showCustomTooltip ? 
                    <div className="contenxt-box">
                      <div className="item">{row.description}</div>
                        {
                          row.description.length > 33 ? <div className="tooltip-content"><div className="text-wrapper"><div className="text">{row.description}</div></div></div> : ""
                        }
                    </div> :
                    row.description !== "" && (
                      <EllipsisWithTooltip placement="bottom">
                        {row.description}
                      </EllipsisWithTooltip>
                    )
                  }
                </button>
              </div>
            </div>
          );
        },
      },
      {
        dataField: "debit",
        text: "Debit",
        headerClasses: "debit",
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "debit-" + rowIndex.toString() + "debit";
          return (
            <div
              className={
                this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active"
                  ? ""
                  : "disabled-area"
              }
            >
              <div className="more-action single-select-image dropdown coa-select">
                <Form.Control
                  tabIndex={this.state.tabEnable}
                  id={id}
                  type="text"
                  value={row.debit}
                  name="debit"
                  placeholder="Enter Amount"
                  className="AmountRight"
                  autoComplete="off"
                  onChange={(e) =>
                    this.updateState(e, row, rowIndex, "debit", id)
                  }
                  onBlur={(e: any) => this.amountBlur(e, rowIndex, "debit", id)}
                  onFocus={(e: any) =>
                    this.onSplitAmountFocus(e, rowIndex, id, "debit")
                  }
                  onKeyDown={this.onTAB.bind(
                    this,
                    "debit-" + rowIndex.toString()
                  )}
                  disabled={row.IsCOAPer?.toLowerCase() === "no" ? true : false}
                  onClick={(e: any) =>
                    handleAllSelect(e, rowIndex, id, "debit")
                  }
                />
              </div>
            </div>
          );
        },
      },
      {
        dataField: "credit",
        text: "Credit",
        headerClasses: "credit",
        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "credit-" + rowIndex.toString() + "credit";
          return (
            <div
              className={
                this.state.formData.accPeriodstatus.toString().toLowerCase() ===
                "active"
                  ? ""
                  : "disabled-area"
              }
            >
              <div className="more-action single-select-image dropdown coa-select">
                <Form.Control
                  tabIndex={this.state.tabEnable}
                  id={id}
                  type="text"
                  value={row.credit}
                  name="credit"
                  placeholder="Enter Amount"
                  className="AmountRight"
                  autoComplete="off"
                  onChange={(e) =>
                    this.updateState(e, row, rowIndex, "credit", id)
                  }
                  onBlur={(e: any) =>
                    this.amountBlur(e, rowIndex, "credit", id)
                  }
                  onFocus={(e: any) =>
                    this.onSplitAmountFocus(e, rowIndex, id, "credit")
                  }
                  onKeyDown={this.onTAB.bind(
                    this,
                    "credit-" + rowIndex.toString()
                  )}
                  disabled={row.IsCOAPer?.toLowerCase() === "no" ? true : false}
                  onClick={(e: any) =>
                    handleAllSelect(e, rowIndex, id, "credit")
                  }
                />
              </div>
            </div>
          );
        },
      },
      {
        dataField: "Attachment",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) => {
          let confirmModalContent = [
            {
              title: "Delete Row",
              desc: "Are you sure you want to delete ?",
              cancleAction: "Cancel",
              ActionTrue: "Delete",
            },
          ];
          if (this.state.splitData.length === 2) {
            return <div></div>;
          } else {
            return (
              <>
                <div
                  className={
                    this.state.formData.accPeriodstatus
                      .toString()
                      .toLowerCase() === "active" &&
                    this.state.formData.concilestatus
                      .toString()
                      .toLowerCase() === "no"
                      ? ""
                      : "disabled-area"
                  }
                >
                  <Dropdown
                    className="more-action confirmation-modal"
                    alignRight
                    tabIndex={this.state.tabDisable}
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more fa-trash"
                      id="dropdown-more-delete"
                      tabIndex={this.state.tabDisable}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <ConfirmationModal
                        confirmModalContent={confirmModalContent}
                        ishandleDeletePosition={this.ishandleDeleteRow.bind(
                          this,
                          row
                        )}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </>
            );
          }
        },
      },
    ];

    const handleAllSelect = (e, rowIndex, txtID, type) => {
      let splitData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.splitData))
      );
      this.setState({ splitData }, () => {
        setTimeout(() => {
          $("#tblSplit")
            .find("input[id^='" + txtID + "']")
            .select();
        }, 50);
      });
    };

    const iconReceiptFormatter = (column, colIndex) => {
      return (
        <div>
          <FontAwesomeIcon icon={faPaperclip} />
        </div>
      );
    };

    const attachmentheader = (column: any, colIndex: any) => {
      return (
        <div className="paperClipBtn">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 448 512"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"></path>
          </svg>
        </div>
      );
    };

    const previousTransactionsColumns = [
      {
        dataField: "accper",
        text: "AP",
        headerClasses: "cl ap",
        classes: "cl ap",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {row.accper}
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: "date",
        text: "Date",
        headerClasses: "jetsDate",
      },
      {
        dataField: "lettercode",
        text: "EHID",
        headerClasses: "jetsEhid",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="">
              <EllipsisWithTooltip placement="bottom">
                {row.lettercode}
              </EllipsisWithTooltip>
            </div>
          );
        },
      },
      {
        dataField: "internalnotes",
        text: "Notes",
        headerClasses: "jetsNotes",
        //hidden: true,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="">
              {/* <EllipsisWithTooltip placement="bottom">{row.internalnotes.length > 0 ? notesIcon() : ""}</EllipsisWithTooltip> */}
              <EllipsisWithTooltip placement="bottom">
                {row.internalnotes}
              </EllipsisWithTooltip>
            </div>
          );
        },
      },
      {
        dataField: "isFile",
        text: "Attachments",
        headerClasses: "jetsAttachments",
        classes: "jetsAttachments",
        headerFormatter: attachmentheader,
        formatter: (cell: any, row: any, rowIndex: any) => {
          if (row.isFile === "Yes") {
            return (
              <button
                className="paperClipBtn"
                onClick={() => this.openFileViewer(row)}
              >
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                </svg>
              </button>
            );
          } else {
            return <div></div>;
          }
        },
      },
      {
        dataField: "debit",
        text: "Debit",
        headerClasses: "jetsAmount",
        classes: "jetsAmount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="">
              <EllipsisWithTooltip placement="bottom">
                {row.dr}
              </EllipsisWithTooltip>
            </div>
          );
        },
      },
      {
        dataField: "credit",
        text: "Credit",
        headerClasses: "jetsAmount",
        classes: "jetsAmount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="">
              <EllipsisWithTooltip placement="bottom">
                {row.cr}
              </EllipsisWithTooltip>
            </div>
          );
        },
      },
    ];

    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderPreviousTableChild(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };
    const renderPreviousTableChild = (mainrow) => {
      let SplitPreviousCOADetail: any = [];
      SplitPreviousCOADetail = this.state.previousTransactionsData.filter(
        (x) => x.uniqueNo === mainrow.uniqueNo && x.mainType === 2
      );
      const columnCOAChild = [
        {
          dataField: "",
          text: "",
          headerClasses: "jetsInvoice",
          classes: "jetsInvoice",
        },
        {
          dataField: "coa",
          text: "COA#",
          headerClasses: "jetsDate",
          classes: "jetsDate",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coa}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "coaName",
          text: "COA Name",
          headerClasses: "jetscoa",
          classes: "jetscoa",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.coaName}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "description",
          text: "Description",
          headerClasses: "description",
          classes: "description",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.description}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "debit",
          text: "Debit",
          headerClasses: "jetsAmount",
          classes: "jetsAmount",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div>{row.dr}</div>;
          },
        },
        {
          dataField: "credit",
          text: "Credit",
          headerClasses: "jetsAmount",
          classes: "jetsAmount",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return <div>{row.cr}</div>;
          },
        },
        {
          dataField: "",
          text: "",
          headerClasses: "jetsInChildTable",
          classes: "jetsInChildTable",
        },
      ];

      return (
        <>
          <BootstrapTable
            id="tblCOAchild"
            keyField="uniqueNo"
            data={SplitPreviousCOADetail}
            columns={columnCOAChild}
          />
        </>
      );
    };

    const notesIcon = () => {
      return (
        <svg
          stroke="currentColor"
          fill="#1d1e20"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="1.2em"
          width="1.2em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M19,4h-3V2h-2v2h-4V2H8v2H5C3.897,4,3,4.897,3,6v14c0,1.103,0.897,2,2,2h14c1.103,0,2-0.897,2-2V6C21,4.897,20.103,4,19,4z M5,20V7h3h2h4h2h3V6l0.002,14H5z"></path>
          <path d="M7 9H17V11H7zM7 13H12V15H7z"></path>
        </svg>
      );
    };
    const isVendorDisabled =
      !this.state.hasEditPermission || this.state.isPermission === "No";

    return (
      <div
        className="transaction-slideout pos-fxd index-1000"
        onKeyDown={(e) => this.hasEditAccess(e)}
      >
        {this.state.showChangeLogModal && (
          <JournalLogHistory
            payPeriodStartDate={""}
            payPeriodEndDate={""}
            showChangeLogModal={this.state.showChangeLogModal}
            showHideChangeLogModal={this.showHideChangeLogModal}
            hotelName={""}
            hotelId={0}
            hideCrossAndClearFilters={false}
            shiftId={this.props.JERequest.UniqueNo}
            shiftDate={""}
            accType={"Journal"}
          />
        )}

        {/* <ToastContainer
          autoClose={3000}
          containerId={"JESave"}
          enableMultiContainer
        /> */}
        <div className="d-flex">
          {/* <div className="back-drop" onClick={this.closeSlideOut}></div> */}
          {!this.state.isOpenViewer && (
            <div
              className="back-drop  viewer-panel opacity"
              onClick={() => this.closeSlideOut()}
            ></div>
          )}
          {this.state.isOpenViewer && (
            <div className="back-drop viewer-panel">
              <div className="header-panel d-flex justify-content-between align-items-center">
                <div className="page-ttl">Attachments</div>
                <div className="toggle-button">
                  <ButtonGroup aria-label="Basic example">
                    <ToggleButtonGroup
                      type="radio"
                      name="options"
                      value={this.state.defaultView}
                      onChange={toggleSwitch}
                    >
                      <ToggleButton value={"doc-view"}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                          <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                        </svg>
                      </ToggleButton>
                      <ToggleButton value={"grid-view"}>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                        </svg>
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </ButtonGroup>
                </div>
                <div className="action d-flex">
                  {this.state.isMapped.toString().toLowerCase() ===
                    "Yes".toString().toLowerCase() && (
                    <button type="button" className="btn wht-bg cross">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.0003 13.3333C11.8387 13.3333 13.3337 11.8383 13.3337 9.99996C13.3337 8.16163 11.8387 6.66663 10.0003 6.66663C8.16199 6.66663 6.66699 8.16163 6.66699 9.99996C6.66699 11.8383 8.16199 13.3333 10.0003 13.3333ZM10.0003 8.33329C10.9037 8.33329 11.667 9.09663 11.667 9.99996C11.667 10.9033 10.9037 11.6666 10.0003 11.6666C9.09699 11.6666 8.33366 10.9033 8.33366 9.99996C8.33366 9.09663 9.09699 8.33329 10.0003 8.33329Z"
                          fill="white"
                        />
                        <path
                          d="M2.37086 13.4466L3.20419 14.8883C3.64669 15.6525 4.71169 15.9391 5.47919 15.4966L5.92003 15.2416C6.40503 15.6225 6.93753 15.935 7.50003 16.1683V16.6666C7.50003 17.5858 8.24753 18.3333 9.16669 18.3333H10.8334C11.7525 18.3333 12.5 17.5858 12.5 16.6666V16.1683C13.0625 15.935 13.595 15.6225 14.08 15.2425L14.5209 15.4975C15.29 15.9391 16.3525 15.6541 16.7967 14.8883L17.6292 13.4475C18.0892 12.6516 17.8159 11.63 17.02 11.1708L16.5992 10.9275C16.6442 10.6183 16.6667 10.3091 16.6667 9.99996C16.6667 9.69079 16.6442 9.38079 16.5992 9.07413L17.02 8.83079C17.8159 8.37079 18.0892 7.34996 17.6292 6.55413L16.7967 5.11329C16.3542 4.34663 15.29 4.05913 14.5209 4.50329L14.08 4.75829C13.595 4.37746 13.0625 4.06496 12.5 3.83163V3.33329C12.5 2.41413 11.7525 1.66663 10.8334 1.66663H9.16669C8.24753 1.66663 7.50003 2.41413 7.50003 3.33329V3.83163C6.93753 4.06496 6.40503 4.37746 5.92003 4.75746L5.47919 4.50246C4.70919 4.05996 3.64586 4.34663 3.20336 5.11246L2.37086 6.55329C1.91086 7.34913 2.18419 8.37079 2.98003 8.82996L3.40086 9.07329C3.35586 9.38079 3.33336 9.69079 3.33336 9.99996C3.33336 10.3091 3.35586 10.6183 3.40086 10.9258L2.98003 11.1691C2.18419 11.6291 1.91086 12.6508 2.37086 13.4466ZM5.14253 11.1483C5.04836 10.7708 5.00003 10.3841 5.00003 9.99996C5.00003 9.61496 5.04836 9.22829 5.14169 8.85163C5.23169 8.49079 5.07253 8.11413 4.75003 7.92829L3.81419 7.38663L4.64586 5.94579L5.60003 6.49746C5.92003 6.68163 6.32253 6.63496 6.59003 6.37913C7.15919 5.83996 7.84586 5.43663 8.57669 5.21329C8.92753 5.10663 9.16669 4.78246 9.16669 4.41663V3.33329H10.8334V4.41663C10.8334 4.78246 11.0725 5.10663 11.4234 5.21329C12.1542 5.43746 12.8409 5.83996 13.41 6.37913C13.6775 6.63496 14.0817 6.68079 14.4 6.49746L15.3534 5.94663L16.1867 7.38746L15.25 7.92829C14.9275 8.11496 14.7684 8.49163 14.8584 8.85163C14.9517 9.22829 15 9.61496 15 9.99996C15 10.3841 14.9517 10.7708 14.8575 11.1483C14.7684 11.5091 14.9275 11.8858 15.25 12.0716L16.1859 12.6125L15.3542 14.0533L14.4 13.5025C14.0809 13.3183 13.6775 13.3641 13.41 13.6208C12.8409 14.16 12.1542 14.5633 11.4234 14.7866C11.0725 14.8933 10.8334 15.2175 10.8334 15.5833L10.835 16.6666H9.16669V15.5833C9.16669 15.2175 8.92753 14.8933 8.57669 14.7866C7.84586 14.5625 7.15919 14.16 6.59003 13.6208C6.43169 13.4691 6.22503 13.3916 6.01669 13.3916C5.87336 13.3916 5.73003 13.4283 5.60003 13.5033L4.64669 14.055L3.81336 12.6141L4.75003 12.0716C5.07253 11.8858 5.23169 11.5091 5.14253 11.1483Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn wht-bg cross"
                    onClick={this.OpenViewer}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <ScrollContainer
                className={`scroll-area ${
                  this.state.modalOpen === "yes" ? "modal-open" : ""
                } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}
                ref={this.scrollheight}
                hideScrollbars={false}
              >
                <>
                  {this.state.savedfiles.map((file: any, i: any) => {
                    return (
                      <div
                        className={this.state.bulkSelect ? "footer-enable" : ""}
                      >
                        <div
                          className={
                            currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                          }
                        >
                          {this.state.isAttachmentLoading ? (
                            <div className="d-flex attachment-Viewer-loader justify-content-center">
                              <Spinner
                                className="d-flex"
                                style={{ margin: "auto" }}
                                animation="border"
                                variant="light"
                              />
                            </div>
                          ) : (
                            <div className="nonInvoicePDFViewer">
                              <PDFViewerNonInvoice
                                //ref={childViewerref}
                                ref={this["myRef" + i]}
                                scrollAreaHeight={this.state.scrollAreaHeight}
                                isModalOpen={this["isModalOpen"]}
                                uniqueno={this.state.invoiceUniqueNo}
                                filePreview={
                                  file.fileCode
                                } /*this.state.fileSelect*/
                                defaultView={currentView}
                                fileNo={file.fileUniqueno}
                                fileCount={savedfilesCount}
                                fileName={file.name}
                                // docFile={docViewerFiles}
                                docFile={allsavedfiles}
                                updateState={handleUpdate}
                                updateFiles={handleUpdateFiles}
                                showBulkSelect={showBulkSelect}
                                checkBulkSelect={checkBulkSelect}
                                handleFileCheckBox={this["handleFileCheckBox"]}
                                handleUpdatedFile={this["handleUpdatedFile"]}
                                handleincompleteFile={
                                  this["handleincompleteFile"]
                                }
                                saveSplitFile={this["saveSplitFile"]}
                                pageType={"Journal"}
                                handleRotate={this["handleRotate"]}
                                handlePageRemove={this["handlePageRemove"]}
                                selectedChk={this.state.selectedChk}
                                selectedZoom={this.state.currentZoom}
                                NoDelPermission={NoDelPermission}
                                isEditPermission={
                                  !this.state.hasEditPermission ||
                                  this.state.isPermission === "No" ||
                                  this.props?.isFromRepeating
                                    ? false
                                    : true
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}

                  {!this.state.isAttachmentLoading && !hideZoombtn && (
                    <>
                      {currentView === "doc-view" && (
                        <div className="zoom-btn">
                          <ButtonGroup vertical>
                            <Button
                              onClick={(e) => this.handleZoom("zoomIn")}
                              disabled={
                                this.state.currentZoom >= 3.375 ? true : false
                              }
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </Button>
                            <Button
                              onClick={(e) => this.handleZoom("zoomOut")}
                              disabled={
                                this.state.currentZoom <= 0.44 ? true : false
                              }
                            >
                              <FontAwesomeIcon icon={faMinus} />
                            </Button>
                          </ButtonGroup>
                        </div>
                      )}
                    </>
                  )}
                  {this.state.bulkSelect && (
                    <div className="footer-section d-flex align-items-center">
                      <Form.Check
                        custom
                        type="checkbox"
                        key={"custom-footer"}
                        id={"custom-footer"}
                        label={"No Page Selected"}
                        onChange={(e: any) => this.handleAllCheckbox(e)}
                        ref={this.footerchk}
                      />
                      <button
                        type="button"
                        onClick={this.handleBulkRemove}
                        className="btn-outline-primary btn btn-primary"
                      >
                        Remove
                      </button>
                      <button
                        type="button"
                        onClick={this.handleBulkRotate}
                        className="btn-outline-primary btn btn-primary mr-auto"
                      >
                        Rotate
                      </button>
                      <button
                        type="button"
                        className="btn wht-bg cross"
                        onClick={this.hideBulkselect}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                    </div>
                  )}
                </>
              </ScrollContainer>
            </div>
          )}
          <Container
            fluid
            className="body-sec viewer-panel"
            id="SlideBody"
            ref={this.parentScroll}
          >
            <div className="page-heading pos-sticky underline d-flex">
              <div className="hid-set d-flex align-items-center">
                {this.state.hotelName}
              </div>
              <div className="mr-auto d-flex align-items-center">
                Journal Entry
              </div>
              <div className="action-group d-flex">
                {this.state.formData.UniqueNo === 0 && (
                  <div className="action-group d-flex">
                    <Form.Check
                      type="switch"
                      id="reversalSwitch"
                      label="Reversal"
                      checked={this.state.isToggleReversal}
                      disabled={this.state.formData.Vid === 0}
                      onChange={(event: any) =>
                        this.handleToggleChange(event, "reversal")
                      }
                    />
                    <Form.Check
                      type="switch"
                      id="repeatSwitch"
                      label="Repeating"
                      checked={this.state.isToggleRepeat}
                      disabled={this.state.formData.Vid === 0}
                      onChange={(event: any) =>
                        this.handleToggleChange(event, "repeat")
                      }
                    />
                  </div>
                )}
                {this.props.isFromRepeating && (
                  <Form.Check
                    type="switch"
                    id="repeatSwitch"
                    label="Repeating"
                    disabled={true}
                    checked={this.state.isToggleRepeat}
                  />
                )}
                {this.state.formData.UniqueNo !== 0 &&
                !this.props?.isFromRepeating ? (
                  <>
                    {this.state.formData.actionType !== "copy" && (
                      <div className="action-group d-flex">
                        <Dropdown
                          className="more-action"
                          alignRight
                          onSelect={this.handleSelect}
                        >
                          <Dropdown.Toggle
                            className="btn-outline-primary btn btn-primary more"
                            id="dropdown-more"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                              <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                              <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {this.state.moreAction.map(
                              (item: any, idx: any) => (
                                <>
                                  {this.hasDeletePermission(
                                    item,
                                    idx,
                                    "nonRepeat"
                                  )}
                                </>
                              )
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                  </>
                ) : (
                  <>{this.renderThreeDot()}</>
                )}

                <button
                  type="button"
                  className="btn wht-bg cross"
                  onClick={this.closeSlideOut}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                      fill="#84888C"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div
              //className={!this.state.hasEditPermission || this.state.isPermission === "No" ? "disabled-area parent" : ""}
              className="parent"
            >
              <div id="filterSec" className="filter-sec">
                <div className="vendor-type-sec d-flex">
                  <Form.Group className="journalvendor">
                    <Form.Label>Vendor</Form.Label>
                    <div
                      tabIndex={this.state.tabEnable}
                      className={
                        !this.state.hasEditPermission ||
                        this.state.isPermission === "No" ||
                        this.props?.isFromRepeating
                          ? "parent"
                          : ""
                      }
                    >
                      <VendorSearch
                        ref={this.vendorSearch}
                        updateVendorList={this.updateVendorList}
                        HID={this.state.hidValue}
                        handleVendorChange={this.handleVendorChange}
                        pageName={this.pageName}
                        disabled={
                          this.props?.isFromRepeating
                            ? this.props?.isFromRepeating
                            : isVendorDisabled
                        }
                      />
                    </div>
                    {this.state.formData.Vid > 0 && (
                      <div
                        className="transactionsLinks"
                        onClick={this.Previoustransactions}
                      >
                        {this.state.isPreviousTransactions
                          ? "Hide Previous Transactions"
                          : "Previous Transactions"}
                      </div>
                    )}
                  </Form.Group>

                  {!this.state.isToggleRepeat && (
                    <div
                      className={
                        this.state.formData.Vid === 0
                          ? "mr-auto d-flex disabled-area"
                          : this.state.formData.accPeriodstatus
                              .toString()
                              .toLowerCase() === "active"
                          ? "mr-auto d-flex"
                          : "mr-auto d-flex disabled-area"
                      }
                    >
                      <Form.Group className="">
                        <Form.Label>Transaction Date</Form.Label>
                        <div className="date-picker calender-picker">
                          <div className="drop-arrow">
                            <svg
                              width="8"
                              height="6"
                              viewBox="0 0 8 6"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                                fill="#3F4347"
                              />
                            </svg>
                          </div>
                          <DatePicker
                            id="trdate"
                            ref={this.trdate}
                            tabIndex={this.state.tabEnable}
                            className={
                              !this.state.hasEditPermission ||
                              this.state.isPermission === "No"
                                ? "disabled-area form-control"
                                : "form-control"
                            }
                            placeholderText={"MM/DD/YY"}
                            dateFormat="MM/dd/yy"
                            autoComplete="off"
                            selected={
                              this.state.formData.Date === ""
                                ? ""
                                : new Date(this.state.formData.Date)
                            }
                            onSelect={(event: any) =>
                              this.handleChange(event, "trDate")
                            }
                            onChange={(event: any) =>
                              this.handleChange(event, "trDate")
                            }
                            //onKeyDown={(e: any) => this.onTAB('trDateRepN', e)}
                            disabled={
                              !this.state.hasEditPermission ||
                              this.state.isPermission === "No"
                                ? true
                                : false
                            }
                          />
                        </div>
                      </Form.Group>

                      <Form.Group className="rm-bottom-margin">
                        <Form.Label>Accounting Period</Form.Label>
                        <div
                          className={
                            !this.state.hasEditPermission ||
                            this.state.isPermission === "No"
                              ? "disabled-area single-select"
                              : "single-select"
                          }
                        >
                          {this.state.accPeriodList.length > 0 ? (
                            <SingleDropdownListWithoutSearch
                              id={"accountingPeriod"}
                              itemList={this.state.accPeriodList}
                              handleSelectedItem={this.handleSelectedItem.bind(
                                this,
                                3 + "_" + 0
                              )}
                              defaultItem={this.state.defaultaccountingPeriod}
                              defaultText={"Accouting Period"}
                              defaultName={this.state.defaultaccountingPeriod}
                              controlID="6"
                            />
                          ) : (
                            <div className="disabled-area">
                              <Dropdown className="more-action bg-blue single-select-image">
                                <Dropdown.Toggle
                                  id="Modal-hid"
                                  className="filter-btn"
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="txt-area">
                                      {this.state.defaultaccountingPeriod}
                                    </div>
                                    <div className="drop-arrow ml-0 d-flex">
                                      <FiChevronDown />
                                    </div>
                                  </div>
                                </Dropdown.Toggle>
                              </Dropdown>
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  )}

                  <div></div>
                </div>

                {this.state.isPreviousTransactions && (
                  <div className="PreviousTransactions previousTransactions">
                    <BootstrapTable
                      keyField="uniqueNo"
                      data={this.state.previousTransactionsData.filter(
                        (x) =>
                          x.mainType === 1 &&
                          x.uniqueNo !=
                            (this.state.formData.actionType === "copy"
                              ? 0
                              : this.state.formData.UniqueNo)
                      )}
                      columns={previousTransactionsColumns}
                      expandRow={expandSplitRow}
                    />
                    <button
                      type="button"
                      className="btn wht-bg link-btn"
                      onClick={this.loadPreviousData}
                    >
                      Show More
                    </button>
                  </div>
                )}

                {this.state.isToggleRepeat && (
                  <div
                    className={
                      this.state.formData.Vid === 0
                        ? "d-flex isPreviousTransactions disabled-area"
                        : this.state.formData.accPeriodstatus
                            .toString()
                            .toLowerCase() === "active" &&
                          this.state.formData.concilestatus
                            .toString()
                            .toLowerCase() === "no"
                        ? "d-flex isPreviousTransactions"
                        : "d-flex isPreviousTransactions disabled-area"
                    }
                  >
                    <Form.Group className="rm-bottom-margin">
                      <Form.Label>Repeat</Form.Label>
                      {/* <div className="single-select">
                        <Form.Control
                          type="text"
                          tabIndex={this.state.tabEnable}
                          placeholder="Enter Account Name"
                          value={"Monthly"}
                          disabled
                        />
                      </div> */}
                      <div className="single-select">
                        <Dropdown className="more-action bg-blue single-select-image repeat">
                          <Dropdown.Toggle variant="success" id="dropdown-basic" className="filter-btn">
                            <div className="d-flex align-items-center">
                              <div className="txt-area">
                                <EllipsisWithTooltip placement="bottom">
                                  {this.state.repeatList.filter((item) => item.name.toLowerCase() === this.state.selectedRepeatType?.toLowerCase()).length > 0 ?
                                    this.state.repeatList.filter((item) => item.name.toLowerCase() === this.state.selectedRepeatType?.toLowerCase())[0].displayName : "Select"}
                                </EllipsisWithTooltip>
                              </div>
                              <div className="drop-arrow ml-auto">
                                <FiChevronDown />
                              </div>
                            </div>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {this.state.repeatList.map(
                              (item: any, idx: any) => (
                                <Dropdown.Item
                                  eventKey={item.displayName}
                                  onClick={() => this.onSelectRepeatType(item)}
                                >
                                  <EllipsisWithTooltip placement="bottom">
                                    {item.displayName}
                                  </EllipsisWithTooltip>
                                </Dropdown.Item>
                              )
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Form.Group>
                    <Form.Group className="rm-bottom-margin">
                      <Form.Label>Transaction Date</Form.Label>
                      <div className="date-picker calender-picker">
                        <div className="drop-arrow">
                          <svg
                            width="8"
                            height="6"
                            viewBox="0 0 8 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                              fill="#3F4347"
                            />
                          </svg>
                        </div>
                        <DatePicker
                          id="repDate"
                          ref={this.trdate1}
                          tabIndex={this.state.tabEnable}
                          className="form-control"
                          placeholderText={"MM/DD/YY"}
                          dateFormat="MM/dd/yy"
                          autoComplete="off"
                          selected={
                            this.state.formData.Date === ""
                              ? ""
                              : new Date(this.state.formData.Date)
                          }
                          onSelect={(event: any) =>
                            this.handleChange(event, "trDate")
                          }
                          //onKeyDown={(e: any) => this.onTAB('trDateRepY', e)}
                        />
                      </div>
                    </Form.Group>
                    <Form.Group className="rm-bottom-margin">
                      <Form.Label>End Date</Form.Label>
                      <div className="date-picker calender-picker">
                        <div className="drop-arrow">
                          <svg
                            width="8"
                            height="6"
                            viewBox="0 0 8 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                              fill="#3F4347"
                            />
                          </svg>
                        </div>
                        <DatePicker
                          id="trenddate"
                          ref={this.trenddate}
                          tabIndex={this.state.tabEnable}
                          className="form-control"
                          placeholderText={"No End Date"}
                          dateFormat="MM/dd/yy"
                          autoComplete="off"
                          selected={
                            this.state.formData.RepeatDate === "No End Date"
                              ? ""
                              : new Date(this.state.formData.RepeatDate)
                          }
                          onBlur={(event) =>
                            this.endDatefocousOut(event.target.value)
                          }
                          onSelect={(event: any) =>
                            this.handleChange(event, "endDate")
                          }
                          //onKeyDown={(e: any) => this.onTAB('trEndDateRepY', e)}
                        />
                      </div>
                    </Form.Group>
                  </div>
                )}

                {this.state.isToggleReversal && (
                  <div
                    className={
                      this.state.formData.Vid === 0
                        ? "mr-auto d-flex disabled-area"
                        : this.state.formData.accPeriodstatus
                            .toString()
                            .toLowerCase() === "active"
                        ? "mr-auto d-flex"
                        : "mr-auto d-flex disabled-area"
                    }
                  >
                    <Form.Group className="">
                      <Form.Label>Reversal Date</Form.Label>
                      <div className="date-picker calender-picker">
                        <div className="drop-arrow">
                          <svg
                            width="8"
                            height="6"
                            viewBox="0 0 8 6"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.0544669 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z"
                              fill="#3F4347"
                            />
                          </svg>
                        </div>
                        <DatePicker
                          id="reversalDate"
                          ref={this.trdate}
                          tabIndex={this.state.tabEnable}
                          className="form-control"
                          placeholderText={"MM/DD/YY"}
                          dateFormat="MM/dd/yy"
                          autoComplete="off"
                          selected={
                            this.state.formData.ReversalDate === ""
                              ? ""
                              : new Date(this.state.formData.ReversalDate)
                          }
                          onSelect={(event: any) =>
                            this.handleChange(event, "revDate")
                          }
                          onChange={(event: any) =>
                            this.handleChange(event, "revDate")
                          }
                          //onKeyDown={(e: any) => this.onTAB('revDate', e)}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="rm-bottom-margin">
                      <Form.Label>Reversal Accounting Period</Form.Label>
                      <div className="single-select singleSelectReversal">
                        {this.state.accPeriodList.length > 0 ? (
                          <div className="hasReversalEntry">
                            <svg
                              stroke="currentColor"
                              fill="none"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                            <SingleDropdownListWithoutSearch
                              id={"accountingPeriod"}
                              itemList={this.state.accPeriodList}
                              handleSelectedItem={this.handleSelectedItem.bind(
                                this,
                                4 + "_" + 0
                              )}
                              defaultItem={this.state.defaultReversalAcPeriod}
                              defaultText={"Accouting Period"}
                              defaultName={this.state.defaultReversalAcPeriod}
                              controlID="6"
                            />
                            <Form.Control
                              id="reversalEntry"
                              type="text"
                              value={this.state.defaultReversalAcPeriod}
                              autoComplete="off"
                              className="reversalInput"
                            />
                          </div>
                        ) : (
                          <div className="disabled-area">
                            <Dropdown className="more-action bg-blue single-select-image">
                              <Dropdown.Toggle
                                id="Modal-hid"
                                className="filter-btn"
                              >
                                <div className="d-flex align-items-center">
                                  <div className="txt-area">
                                    {this.state.defaultaccountingPeriod}
                                  </div>
                                  <div className="drop-arrow ml-0 d-flex">
                                    <FiChevronDown />
                                  </div>
                                </div>
                              </Dropdown.Toggle>
                            </Dropdown>
                          </div>
                        )}
                      </div>
                    </Form.Group>
                  </div>
                )}

                <div
                  className={
                    !this.state.hasEditPermission ||
                    this.state.isPermission === "No" ||
                    this.state.formData.Vid <= 0 ||
                    this.state.isError === "NotEdit"
                      ? "disabled-area notes-section"
                      : "notes-section"
                  }
                >
                  <Form.Group>
                    <Form.Label>Notes</Form.Label>
                    <Form.Control
                      id="txtNotes"
                      as="textarea"
                      wrap="hard"
                      rows={3}
                      value={this.state.formData.Internalnotes}
                      maxLength={99}
                      onChange={(event: any) =>
                        this.handleChange(event, "notes")
                      }
                      onKeyDown={(e: any) => this.onTAB("txtNotes-0", e)}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>

            <div
              className={this.state.formData.Vid === 0 ? "disabled-area" : ""}
            >
              <div
                className={
                  !this.state.hasEditPermission ||
                  this.state.isPermission === "No"
                    ? "disabled-area parent"
                    : ""
                }
              >
                <div
                  className="transactions-list inpute JEtransactionsList"
                  id="JEtransactionsList"
                >
                  <BootstrapTable
                    id="tblSplit"
                    keyField="rno"
                    data={this.state.splitData}
                    columns={transactionsColumns}
                  />

                  <div className="">
                    <div className="JEtransactionsList">
                      <table className="reactBootstrapTable table-bordered">
                        <tbody>
                          <tr>
                            <td>
                              <button
                                type="button"
                                className="btn wht-bg link-btn mr-auto"
                                onClick={this.handleNewRow}
                                disabled={
                                  this.state.formData.accPeriodstatus
                                    .toString()
                                    .toLowerCase() === "active" &&
                                  this.state.formData.concilestatus
                                    .toString()
                                    .toLowerCase() === "no"
                                    ? false
                                    : this.state.formData.Vid === 0
                                    ? false
                                    : true
                                }
                              >
                                Add Row
                              </button>
                              {/* <button type="button" className="btn wht-bg link-btn mr-auto">Clear All</button> */}
                            </td>
                            <td>Total:</td>
                            {/* <td>{Number(this.state.totalDebitAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</td>
                                                        <td>{Number(this.state.totalCreditAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</td> */}
                            <td>
                              {Utils.currencyFormat(
                                this.state.totalDebitAmount
                              )}
                            </td>
                            <td>
                              {Utils.currencyFormat(
                                this.state.totalCreditAmount
                              )}
                            </td>
                            <td>
                              {Number(this.state.transTotalAmount) !== 0 ? (
                                <span className="text-danger">
                                  {Utils.currencyFormat(
                                    this.state.transTotalAmount
                                  )}
                                </span>
                              ) : (
                                <span>
                                  {Utils.currencyFormat(
                                    this.state.transTotalAmount
                                  )}
                                </span>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="filter-sec upload-section">
                {/* <Form.Group
                                        className={(this.state.formData.accPeriodstatus.toString().toLowerCase() === "active") ? "" : "disabled-area"}>
                                        <Form.Label>Notes</Form.Label>
                                        <Form.Control id="txtNotes" as="textarea" wrap="hard" rows={3} value={this.state.formData.Internalnotes}
                                            maxLength={99}
                                            onChange={(event: any) => this.handleChange(event, 'notes')}                                        
                                        />
                                    </Form.Group> */}

                <Form.Group>
                  {/* !this.state.isToggleRepeat &&  */}
                  {this.props.pageFrom !== undefined &&
                  this.props.pageFrom === "repeatingPage" ? (
                    <></>
                  ) : (
                    <>
                      {!this.state.isToggleReversal && (
                        <>
                          <div className="d-flex">
                            <Form.Label className="mr-auto">
                              Attachments
                            </Form.Label>
                            <div className="d-flex">
                              {this.state.savedfiles.length > 0 && (
                                <div className="upload-link">
                                  <button
                                    type="button"
                                    className="btn wht-bg link-btn mr-auto"
                                    onClick={this.OpenViewer}
                                  >
                                    {this.state.isOpenViewer
                                      ? "Close Viewer"
                                      : "Open Viewer"}
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                          <Dropzone
                            onDrop={this.onDrop}
                            // accept="image/*,application/pdf,
                            // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                            // application/vnd.ms-excel,
                            // application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                            // text/plain,
                            // .doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                          >
                            {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                              isDragReject,
                            }) => (
                              <section
                                className={
                                  isDragActive
                                    ? "container upload-area default drag-active "
                                    : "container upload-area default"
                                }
                              >
                                {/* <div className={!this.state.hasEditPermission || this.state.isPermission === "No" ? "disabled-area" : ""}></div> */}
                                <div
                                  id="droparea"
                                  onKeyDown={(event: any) =>
                                    this.handleKeyDown(event, "droparea")
                                  }
                                  {...getRootProps({
                                    className:
                                      "dropzone d-flex align-items-center",
                                    onClick:
                                      this.state.newSelectedfiles.length > 0 ||
                                      this.state.savedfiles.length > 0
                                        ? (event) => event.stopPropagation()
                                        : (event) => event,
                                  })}
                                >
                                  <input {...getInputProps()} />
                                  {this.state.newSelectedfiles.length < 1 &&
                                    this.state.savedfiles.length < 1 && (
                                      <p>
                                        Drag and drop Document or{" "}
                                        <span>browse files</span> to upload.
                                      </p>
                                    )}
                                  {(this.state.newSelectedfiles.length > 0 ||
                                    this.state.savedfiles.length > 0) &&
                                    isDragActive && (
                                      <p>
                                        Drag and drop Document here to upload.
                                      </p>
                                    )}
                                </div>

                                {(this.state.newSelectedfiles.length > 0 ||
                                  this.state.savedfiles.length > 0) && (
                                  <aside className="d-flex flex-column file-area">
                                    <ul>{files}</ul>
                                    <ul>{files1}</ul>
                                  </aside>
                                )}
                              </section>
                            )}
                          </Dropzone>
                          <div className="d-flex">
                            {(this.state.newSelectedfiles.length > 0 ||
                              this.state.savedfiles.length > 0) && (
                              <div className="upload-link mt-2 addAttachmentButton">
                                {/* className={!this.state.hasEditPermission || this.state.isPermission === "No" ? "upload-link disabled-area" : "upload-link"} */}
                                <button
                                  type="button"
                                  className="btn wht-bg link-btn mr-auto"
                                >
                                  Add Attachment
                                </button>
                                <Form.Control
                                  id="formControlsFile"
                                  type="file"
                                  multiple
                                  onChange={(event: any) =>
                                    this.onFileChange(event, "1")
                                  }
                                  tabIndex={this.state.tabEnable}
                                  accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                />
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </Form.Group>
              </div>

              {this.state.isComment && !this.state.isToggleRepeat && (
                <div className={isFooterDisable ? "" : "footer-show"}>
                  <CommentBox
                    ref={this.ChildComment}
                    hotelid={this.state.requestlist.hotelID}
                    entryType={
                      this.props.isFromRepeating ? "Journalrepeat" : "Journal"
                    }
                    uniqueNo={
                      this.state.formData.actionType === "copy"
                        ? 0
                        : this.props.JERequest.UniqueNo
                    }
                    precommentlist={this.state.htmlcomment}
                    parentScrollMethod={this.scrollToBottom}
                    updatedCommentItem={this.updatedCommentItem}
                  />
                </div>
              )}
              {this.state.formData.Vid !== 0 && !isFooterDisable && (
                <div className="viewer-panel footer-section">
                  <div className="d-flex align-items-center justify-content-end height-72">
                    {this.state.JERequests.UniqueNo === 0 && (
                      <Form.Group>
                        <Form.Check
                          id="chkAnother"
                          type="checkbox"
                          label="Create Another"
                          checked={this.state.createOther}
                          onChange={(event: any) =>
                            this.handleChange(event, "createOther")
                          }
                          onKeyDown={(event: any) =>
                            this.handleKeyDown(event, "createOther")
                          }
                          custom
                        />
                      </Form.Group>
                    )}

                    <Button
                      variant="primary"
                      type="button"
                      className="space btn btn-primary btn-discard"
                      onClick={this.closeSlideOut}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="primary"
                      id="btnSavetran"
                      type="button"
                      onClick={this.SaveJournalEntry}
                      disabled={isEnableForUpload ? true : isFooterDisable}
                    >
                      {/* {this.state.isDisabled && (<><Spinner size="sm" animation="border" /></>)}{" "} */}
                      Save Entry
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Container>

          {(this.state.isSpinner || this.state.isDisabled) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

          <Modal
            backdrop="static"
            keyboard={false}
            show={this.state.alertModalshow}
            className="transferModal"
            onHide={this.alertModalHide}
          >
            <Modal.Header closeButton>
              <Modal.Title>Journal Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Date entered is a future date. Press Cancel to Change, OK to
                Continue.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button className="btnCancel" onClick={this.alertModalHide}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.saveDepositeEntry}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}
